(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9426],{

/***/ 33830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AddToBasket_AddToBasket; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/components/features/Basket/components/AddToBasket/AddToBasket.module.scss
var AddToBasket_module = __webpack_require__(71437);
var AddToBasket_module_default = /*#__PURE__*/__webpack_require__.n(AddToBasket_module);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(31781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(53083);
// EXTERNAL MODULE: ./src/components/features/Basket/index.ts + 9 modules
var Basket = __webpack_require__(55057);
// EXTERNAL MODULE: ./src/components/features/Basket/hooks/useBasketPaths.ts
var useBasketPaths = __webpack_require__(42386);
// EXTERNAL MODULE: ./src/shared/hooks/useNotification/index.ts + 2 modules
var useNotification = __webpack_require__(78560);
// EXTERNAL MODULE: ./src/components/features/Basket/service/index.ts + 4 modules
var service = __webpack_require__(87669);
// EXTERNAL MODULE: ./src/components/features/Basket/utils/format.ts
var format = __webpack_require__(53279);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 6 modules
var hooks = __webpack_require__(76345);
;// CONCATENATED MODULE: ./src/components/features/Basket/hooks/useBasketAdd.ts








const useBasketAdd = () => {
  const {
    push
  } = (0,useNotification/* useNotification */.l)();
  const {
    basketLineUrl,
    basketQueryKey
  } = (0,useBasketPaths/* useBasketPaths */._)();
  const {
    toggleMiniBasket,
    setBasketId
  } = (0,Basket/* useBasketState */.ZJ)();
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    isLoading,
    mutateAsync: add
  } = (0,useMutation/* useMutation */.D)(args => (0,service/* addItem */.jX)(args, basketLineUrl, session === null || session === void 0 ? void 0 : session.accessToken), {
    onSuccess: basket => {
      var _basket$conversionErr;

      if ((_basket$conversionErr = basket.conversionErrors) !== null && _basket$conversionErr !== void 0 && _basket$conversionErr.length) {
        toggleMiniBasket(false);
        basket.conversionErrors.forEach(error => {
          push({
            severity: 'warning',
            text: error
          });
        });
      } else {
        push({
          severity: 'success',
          text: translate('notifications.newItemAddedToBasket')
        });
      }

      queryClient.setQueryData([basketQueryKey], basket);

      if (basket.id) {
        setBasketId(basket.id);
      }
    },
    onError: async error => {
      toggleMiniBasket(false);
      const {
        level,
        errorMessages
      } = await (0,format/* errorToJson */.N)(error);
      push({
        severity: level,
        text: errorMessages
      });
    }
  });
  return {
    isLoading,
    add
  };
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/AddToBasket/AddToBasket.tsx









const isJPGroup = (0,dist.isJPG)();

const closestVal = function (value) {
  let colli = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const leftover = value % colli;
  if (leftover === 0) return value;
  return value + (colli - leftover);
};

const AddToBasket = _ref => {
  let {
    productId,
    variantId,
    small,
    buttonText,
    iconName,
    defaultValue,
    hideButtonText,
    colli,
    isFlexible,
    className
  } = _ref;
  // if HOW ignore colly and use 1
  const defaultQuantity = isJPGroup ? defaultValue || colli || 1 : 1;
  const colliVal = isJPGroup ? colli : 1;
  const {
    0: quantity,
    1: setQuantity
  } = (0,react.useState)(defaultQuantity);
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    add
  } = useBasketAdd();

  const addToBasket = async () => {
    const closestQuantity = closestVal(quantity, colliVal);
    setQuantity(closestQuantity);

    if (productId) {
      await add({
        productId,
        quantity: closestQuantity
      });
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,clsx_m/* default */.Z)((AddToBasket_module_default()).root, className),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InputStepper */.zJ, {
      inputName: `${productId}${variantId}`,
      colli: colliVal,
      defaultValue: quantity,
      small: small,
      onChange: val => setQuantity(val)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      "aria-label": "Add to basket value",
      isFlexible: isFlexible,
      onClick: addToBasket,
      size: small ? 'small' : 'medium',
      iconName: iconName || 'shopping-cart',
      children: !hideButtonText && (buttonText || translate('productPage.addToBasket.text'))
    })]
  });
};

/* harmony default export */ var AddToBasket_AddToBasket = (/*#__PURE__*/(0,react.memo)(AddToBasket));

/***/ }),

/***/ 61160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kc": function() { return /* reexport */ useBasket; },
  "_x": function() { return /* reexport */ useBasketPaths/* useBasketPaths */._; },
  "ZJ": function() { return /* reexport */ useBasketState/* useBasketState */.Z; },
  "e7": function() { return /* reexport */ useUpdateShipping; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
// EXTERNAL MODULE: ./src/components/features/Basket/hooks/useBasketState.ts
var useBasketState = __webpack_require__(37866);
// EXTERNAL MODULE: ./src/components/features/Basket/hooks/useBasketPaths.ts
var useBasketPaths = __webpack_require__(42386);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(72603);
;// CONCATENATED MODULE: ./src/components/features/Basket/constants/keys.ts
const BASKET_STORAGE_KEY = 'basket-id';
const BASKET_TIMESTAMP_KEY = 'basket-timestamp';
// EXTERNAL MODULE: ../../node_modules/.pnpm/@rehooks+local-storage@2.4.4_react@18.2.0/node_modules/@rehooks/local-storage/lib/index.js
var lib = __webpack_require__(25069);
// EXTERNAL MODULE: ./src/shared/hooks/useNotification/index.ts + 2 modules
var useNotification = __webpack_require__(78560);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/features/Basket/utils/format.ts
var format = __webpack_require__(53279);
// EXTERNAL MODULE: ./src/services/query-client.ts
var query_client = __webpack_require__(47982);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 6 modules
var hooks = __webpack_require__(76345);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/index.ts + 10 modules
var P181Profile = __webpack_require__(67975);
;// CONCATENATED MODULE: ./src/components/features/Basket/hooks/useBasket.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














/**
 * Exposes basket data and actions.
 */

const useBasket = () => {
  const queryClient = (0,query_client/* useQueryClient */.N)();
  const {
    data: userInformation,
    refetch: refetchCustomer
  } = (0,P181Profile.useUserInformation)();
  const uIState = (0,useBasketState/* useBasketState */.Z)();
  const {
    basketId,
    setBasketId
  } = uIState;
  const {
    basketUrl,
    basketQueryKey
  } = (0,useBasketPaths/* useBasketPaths */._)();
  const {
    push
  } = (0,useNotification/* useNotification */.l)();
  const [localStorageBasketId, setLocalStorageBasketId] = (0,lib/* useLocalStorage */._)(BASKET_STORAGE_KEY, null);
  const {
    session,
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    data: basket,
    error,
    isLoading,
    isError,
    isStale,
    status,
    refetch,
    remove
  } = (0,useQuery/* useQuery */.a)([basketQueryKey], (0,utils/* getRequest */.A_)(basketUrl, {
    'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
  }), {
    enabled: Boolean(basketId) && (!(0,dist.isJPG)() || (0,dist.isJPG)() && isAuthenticated),
    // Set basket to stale after  5 minutes
    staleTime: 5 * 60 * 1000,
    // 5 minutes
    // Make sure we refetch basket always on focus
    refetchOnWindowFocus: 'always',
    retry: (failureCount, error) => {
      if (error instanceof Response && (error === null || error === void 0 ? void 0 : error.status) === 404) {
        if (!(userInformation !== null && userInformation !== void 0 && userInformation.basketId)) {
          setBasketId(null);
          queryClient.removeQueries([basketQueryKey], {
            exact: true
          }); // TODO: Basket gone figure out what to show to the user

          return false;
        }
      }

      return failureCount < 3;
    },
    onError: async error => {
      const {
        level,
        errorMessages
      } = await (0,format/* errorToJson */.N)(error);
      push({
        severity: level,
        text: errorMessages
      });
    },
    onSuccess: basket => {
      if (!basketId || basketId !== basket.id) {
        setBasketId(basket.id);
      }
    }
  });

  async function deleteBasketService() {
    try {
      await fetch(basketUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
    } catch (error) {
      push({
        severity: 'warning',
        text: 'Failed to delete basket'
      });
    }
  }

  (0,react.useEffect)(() => {
    if (!basketId && localStorageBasketId) {
      setBasketId(localStorageBasketId);
    }
  }, []);
  (0,react.useEffect)(() => {
    if (!basketId) {
      (0,lib/* deleteFromStorage */.DC)(BASKET_STORAGE_KEY);
    }

    if (basketId !== localStorageBasketId) {
      setLocalStorageBasketId(basketId);
    }
  }, [basketId]);
  (0,react.useEffect)(() => {
    if (userInformation !== null && userInformation !== void 0 && userInformation.basketId) {
      setBasketId(userInformation === null || userInformation === void 0 ? void 0 : userInformation.basketId);
    }
  }, [userInformation === null || userInformation === void 0 ? void 0 : userInformation.basketId]);
  const totalQuantity = (0,react.useMemo)(() => {
    var _basket$lines;

    return basket === null || basket === void 0 ? void 0 : (_basket$lines = basket.lines) === null || _basket$lines === void 0 ? void 0 : _basket$lines.reduce((acc, _ref) => {
      let {
        quantity = 1
      } = _ref;
      return acc + quantity;
    }, 0);
  }, [basket === null || basket === void 0 ? void 0 : basket.lines]);

  const clearBasketCache = () => {
    setBasketId(null);
    queryClient.removeQueries([basketQueryKey], {
      exact: true
    });
    remove();
  };

  const refetchCustomerAfterDelete = async () => {
    const {
      data: newCustomerData
    } = await refetchCustomer();
    (newCustomerData === null || newCustomerData === void 0 ? void 0 : newCustomerData.basketId) && setBasketId(newCustomerData === null || newCustomerData === void 0 ? void 0 : newCustomerData.basketId);
  };

  const deleteBasket = async deleteFromDB => {
    if (userInformation !== null && userInformation !== void 0 && userInformation.basketId) {
      deleteFromDB && (await deleteBasketService());
      clearBasketCache();

      if (deleteFromDB) {
        window.setTimeout(() => {
          refetchCustomerAfterDelete();
        }, 5000);
      }
    } else {
      clearBasketCache();
    } // router.reload()

  };

  return _objectSpread(_objectSpread({}, uIState), {}, {
    data: basket,
    totalQuantity,
    status,
    error,
    isLoading: isLoading && Boolean(basketId),
    isError,
    isStale,
    refetch,
    remove,
    deleteBasket
  });
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(31781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(53083);
// EXTERNAL MODULE: ./src/components/features/Basket/service/index.ts + 4 modules
var service = __webpack_require__(87669);
;// CONCATENATED MODULE: ./src/components/features/Basket/hooks/useUpdateShipping.ts







const useUpdateShipping = () => {
  const {
    push
  } = (0,useNotification/* useNotification */.l)();
  const {
    shippingMethodUrl,
    basketQueryKey
  } = (0,useBasketPaths/* useBasketPaths */._)();
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    setBasketId
  } = (0,useBasketState/* useBasketState */.Z)();
  const {
    isLoading,
    mutateAsync: update
  } = (0,useMutation/* useMutation */.D)(args => (0,service/* updateShipping */.JT)(args, shippingMethodUrl, session === null || session === void 0 ? void 0 : session.accessToken), {
    onSuccess: basket => {
      var _basket$conversionErr;

      if ((_basket$conversionErr = basket.conversionErrors) !== null && _basket$conversionErr !== void 0 && _basket$conversionErr.length) {
        basket.conversionErrors.forEach(error => {
          push({
            severity: 'warning',
            text: error
          });
        });
      } else {// push({ severity: 'success', text: `Shipping Method updated` });
      }

      queryClient.setQueryData([basketQueryKey], basket);

      if (basket.id) {
        setBasketId(basket.id);
      }
    },
    onError: async error => {
      const {
        level,
        errorMessages
      } = await (0,format/* errorToJson */.N)(error);
      push({
        severity: level,
        text: errorMessages
      });
    }
  });
  return {
    isLoading,
    update
  };
};
;// CONCATENATED MODULE: ./src/components/features/Basket/hooks/index.ts





/***/ }),

/***/ 42386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useBasketPaths; }
/* harmony export */ });
/* harmony import */ var _services_globalization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72201);
/* harmony import */ var _useBasketState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37866);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76345);



const useBasketPaths = () => {
  const {
    checkoutBaseUrl
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .usePrefixUrl */ .Yp)();
  const {
    basketId
  } = (0,_useBasketState__WEBPACK_IMPORTED_MODULE_1__/* .useBasketState */ .Z)();
  const {
    currentMarket
  } = (0,_services_globalization__WEBPACK_IMPORTED_MODULE_0__/* .useMarkets */ .i)();
  const marketKey = currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.storeKey;
  const basketQueryKey = `Basket-${marketKey}-${currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.countryCode}-${currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.countryCode}`; // Basket

  const basketUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}`;
  const basketLineUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}/Line`;
  const basketUploadCSVUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}/csv`; // Buyer information

  const addBuyerInformationSubmitUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}/CustomerInformation/isCheckout=true`; // Shipping

  const shippingApiUrl = `${checkoutBaseUrl}/Shipping`;
  const addShippingMethodUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}/Shipping`;
  const shippingMethodUrl = `${checkoutBaseUrl}/Shipping/PostShippingInformation`; // Payment

  const getPaymentOptionsUrl = `${checkoutBaseUrl}/Payment`;
  const addPaymentUrl = `${checkoutBaseUrl}/Basket${basketId ? '/' + basketId : ''}/Payment`;
  const createPaymentUrl = `${checkoutBaseUrl}/Payment`; // Order

  const orderUrl = `${checkoutBaseUrl}/Order`; // confirm Order For Account Sales

  const confirmOrderForAccountSalesUrl = `${checkoutBaseUrl}/Order/{{OrderNumber}}/ConfirmOrderForAccountSales`; // Receipt

  const receiptUrl = `${checkoutBaseUrl}/Order/{{i}}/receipt`;
  return {
    basketUrl,
    basketLineUrl,
    basketUploadCSVUrl,
    basketQueryKey,
    shippingApiUrl,
    addBuyerInformationSubmitUrl,
    addShippingMethodUrl,
    shippingMethodUrl,
    getPaymentOptionsUrl,
    addPaymentUrl,
    createPaymentUrl,
    orderUrl,
    confirmOrderForAccountSalesUrl,
    receiptUrl,
    basketId
  };
};

/***/ }),

/***/ 37866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBasketState; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59938);

const useBasketState = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(set => ({
  basketId: null,
  isMiniBasketOpen: false,
  lastAddedVariantId: '',
  paymentOption: 'payNow',
  setBasketId: basketId => {
    set(() => ({
      basketId
    }));
  },
  setPaymentOption: paymentOption => {
    set(() => ({
      paymentOption
    }));
  },
  toggleMiniBasket: isMiniBasketOpen => {
    set(() => ({
      isMiniBasketOpen
    }));
  }
}));

/***/ }),

/***/ 55057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D1": function() { return /* reexport */ BackArrow; },
  "G6": function() { return /* reexport */ FilterList; },
  "nq": function() { return /* reexport */ LineItem; },
  "ER": function() { return /* reexport */ Summary; },
  "Z8": function() { return /* reexport */ SummaryItem; },
  "N5": function() { return /* reexport */ format/* errorToJson */.N; },
  "Kc": function() { return /* reexport */ hooks/* useBasket */.Kc; },
  "_x": function() { return /* reexport */ hooks/* useBasketPaths */._x; },
  "ZJ": function() { return /* reexport */ hooks/* useBasketState */.ZJ; },
  "e7": function() { return /* reexport */ hooks/* useUpdateShipping */.e7; }
});

// UNUSED EXPORTS: PaymentIcons, Stock, filtersEnum

// EXTERNAL MODULE: ./src/components/features/Basket/hooks/index.ts + 3 modules
var hooks = __webpack_require__(61160);
// EXTERNAL MODULE: ./src/components/features/Basket/utils/format.ts
var format = __webpack_require__(53279);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/components/features/Basket/components/BackArrow/BackArrow.module.css
var BackArrow_module = __webpack_require__(3905);
var BackArrow_module_default = /*#__PURE__*/__webpack_require__.n(BackArrow_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/BackArrow/BackArrow.tsx





const BackArrow = _ref => {
  let {
    onBack
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
    className: (BackArrow_module_default()).arrowButton,
    variant: "secondary",
    iconName: "chevron-left",
    onClick: onBack,
    "aria-describedby": translate('accessibility.goBack')
  });
};
;// CONCATENATED MODULE: ./src/components/features/Basket/components/Stock/Stock.tsx







const Stock = _ref => {
  let {
    inStock = false
  } = _ref;
  const translate = useTranslations();
  const text = inStock ? translate('commerce.stock.available') : translate('commerce.stock.unavailable');
  return _jsxs("div", {
    className: clsx(styles.stock),
    children: [_jsx("div", {
      className: clsx(styles.stockBullet, {
        [styles.available]: inStock,
        [styles.unavailable]: !inStock
      })
    }), _jsx(Text, {
      className: clsx(styles.dispensableText),
      variant: "bodyExtraSmall",
      children: text
    })]
  });
};
// EXTERNAL MODULE: ./src/components/features/index.ts + 21 modules
var features = __webpack_require__(34);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/link.js
var next_link = __webpack_require__(92072);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ./src/components/features/Basket/components/LineItem/LineItem.module.css
var LineItem_module = __webpack_require__(70405);
var LineItem_module_default = /*#__PURE__*/__webpack_require__.n(LineItem_module);
// EXTERNAL MODULE: ./src/components/shared/BaseProductInfo/BaseProductInfo.tsx
var BaseProductInfo = __webpack_require__(39169);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
// EXTERNAL MODULE: ./src/components/features/Favorites/AddFavoriteButton/AddFavoriteButton.tsx
var AddFavoriteButton = __webpack_require__(83509);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/LineItem/LineItem.tsx












const LineItem = /*#__PURE__*/(0,react.memo)(_ref => {
  var _images$, _images$2, _priceOutput$totalPri, _priceOutput$salePric, _priceOutput$salePric2, _priceOutput$unitPric;

  let {
    line,
    onQuantityChange,
    isUpdating
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    images,
    name,
    quantity = 1,
    productId,
    priceOutput,
    jpGroupNumber,
    oldJPGroupNumber,
    brand,
    trafficLight,
    stock,
    packingUnit
  } = line;
  const {
    0: finalQuantity,
    1: setFinalQuantity
  } = (0,react.useState)(quantity);
  const linkUrl = `/p/${(0,dist.stringToSlug)(name || '')}/${productId}/${productId}`;

  const quantityChange = quantity => {
    setFinalQuantity(quantity);
    onQuantityChange && onQuantityChange(quantity);
  };

  (0,react.useEffect)(() => {
    if (!isUpdating) {
      console.log('Stopped Updating');
      setFinalQuantity(quantity);
    }
  }, [isUpdating]);
  const imageUrl = images && (images === null || images === void 0 ? void 0 : images.length) > 0 ? (0,utils/* generateImageUrl */.LJ)({
    size: 'productcarousel',
    fileName: ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.fileName) || '',
    modifiedDateTime: ((_images$2 = images[0]) === null || _images$2 === void 0 ? void 0 : _images$2.modifiedDateTime) || ''
  }) : undefined;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
    className: (LineItem_module_default()).lineItem,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: linkUrl,
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: linkUrl,
        className: (LineItem_module_default()).productLink,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseProductInfo/* default */.Z, {
          productName: name,
          imgSrc: imageUrl,
          jpGroupNumber: jpGroupNumber,
          oeNumber: oldJPGroupNumber,
          brand: brand
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (LineItem_module_default()).lineFavorites,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddFavoriteButton/* default */.Z, {
        productId: productId
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* StockStatus */.BQ, {
      statusCode: trafficLight,
      productId: productId,
      amount: stock
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (LineItem_module_default()).lineStepper,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* InputStepper */.zJ, {
        defaultValue: finalQuantity,
        onChange: v => quantityChange(v),
        colli: Number(packingUnit || 1)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        variant: "link",
        onClick: () => quantityChange(0),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "b",
          variant: "bodySmall",
          children: translate('commerce.basket.removeProductButton')
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* PriceGroup */.NO, {
      className: (LineItem_module_default()).linePrice,
      displayPriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$totalPri = priceOutput.totalPrice) === null || _priceOutput$totalPri === void 0 ? void 0 : _priceOutput$totalPri.displayTaxedPrice,
      displaySalePriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric = priceOutput.salePrice) === null || _priceOutput$salePric === void 0 ? void 0 : _priceOutput$salePric.displayTaxedPrice,
      displayUnitPriceInclTax: priceOutput !== null && priceOutput !== void 0 && priceOutput.salePrice ? priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric2 = priceOutput.salePrice) === null || _priceOutput$salePric2 === void 0 ? void 0 : _priceOutput$salePric2.displayTaxedPrice : priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$unitPric = priceOutput.unitPrice) === null || _priceOutput$unitPric === void 0 ? void 0 : _priceOutput$unitPric.displayTaxedPrice,
      isOnSale: (priceOutput === null || priceOutput === void 0 ? void 0 : priceOutput.salePrice) !== null,
      variant: "body"
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/features/Basket/components/PaymentIcons/PaymentIcons.tsx






const PaymentIcons = _ref => {
  var _frame$footer, _frame$footer$payment;

  let {
    center
  } = _ref;
  const {
    data: frame
  } = useFrame();
  return _jsx("ul", {
    className: clsx(styles.paymentIcons, {
      [styles.center]: center
    }),
    children: frame === null || frame === void 0 ? void 0 : (_frame$footer = frame.footer) === null || _frame$footer === void 0 ? void 0 : (_frame$footer$payment = _frame$footer.paymentIcons) === null || _frame$footer$payment === void 0 ? void 0 : _frame$footer$payment.map((_ref2, index) => {
      let {
        image,
        title
      } = _ref2;
      return (image === null || image === void 0 ? void 0 : image.src) && _jsx("li", {
        children: _jsx(Image, {
          src: image.src,
          title: title,
          alt: title,
          width: 35,
          height: 24,
          layout: "intrinsic",
          objectFit: "contain"
        })
      }, image.src + index);
    })
  });
};
// EXTERNAL MODULE: ./src/components/features/Basket/components/Summary/Summary.module.css
var Summary_module = __webpack_require__(75473);
var Summary_module_default = /*#__PURE__*/__webpack_require__.n(Summary_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/Summary/Summary.tsx









const Summary = _ref => {
  var _sum$totalPrice;

  let {
    sum
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();

  const isJSX = value => {
    if (!value) {
      return false;
    }

    return value.props !== undefined;
  };

  const TableRow = _ref2 => {
    let {
      children,
      value,
      discount
    } = _ref2;
    // Don't render components without a value
    return isJSX(value) && value.props.children || value ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
        className: (0,clsx_m/* default */.Z)((Summary_module_default()).descriptionTableData),
        children: children
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
        className: (0,clsx_m/* default */.Z)((Summary_module_default()).summaryTableData, {
          [(Summary_module_default()).discount]: discount
        }),
        children: value
      })]
    }) : null;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("table", {
    className: (0,clsx_m/* default */.Z)(src/* textStyles.text */.sq.text, src/* textStyles */.sq[`variant-body`], src/* textStyles.as-table */.sq["as-table"], (Summary_module_default()).summary),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tbody", {
      children: [(sum === null || sum === void 0 ? void 0 : sum.freightAmount) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableRow, {
          children: translate('commerce.price.delivery'),
          value: sum.freightAmount
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
            colSpan: 2,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: (Summary_module_default()).summaryDivider
            })
          })
        })]
      }), !(0,dist.isJPG)() && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableRow, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "body",
          as: "b",
          className: (Summary_module_default()).summaryText,
          children: translate('commerce.price.tax')
        }),
        value: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "body",
          as: "b",
          className: (Summary_module_default()).summaryText,
          children: sum === null || sum === void 0 ? void 0 : (_sum$totalPrice = sum.totalPrice) === null || _sum$totalPrice === void 0 ? void 0 : _sum$totalPrice.displayTaxValue
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableRow, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "body",
          as: "b",
          className: (Summary_module_default()).summaryText,
          children: translate('commerce.price.priceWithTax')
        }),
        value: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "body",
          as: "b",
          className: (Summary_module_default()).summaryText,
          children: sum === null || sum === void 0 ? void 0 : sum.totalPriceInclShipping
        })
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.3.0_bt6w5v66yle5u77vjwdlnsfv6e/node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 2 modules
var emotion_styled_base_browser_esm = __webpack_require__(93251);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 4 modules
var es = __webpack_require__(71166);
// EXTERNAL MODULE: ./src/theme/index.ts + 6 modules
var src_theme = __webpack_require__(49577);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/SummaryItem/styled.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



const StyledSummaryItem = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lnil222"
} : 0)(_ref => {
  let {
    theme
  } = _ref;
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    gap: theme.spaces[3],
    padding: `${theme.spaces[3]} 0`,
    [src_theme/* breakpoints.md */.AV.md]: {
      padding: `${theme.spaces[3]} ${theme.spaces[4]}`
    }
  };
},  true ? "" : 0);
const StyledSummaryContent = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lnil221"
} : 0)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'flex',
    justifySelf: `${(0,es/* prop */.vg)('justifySelf', 'flex-start')}`,
    flexDirection: 'column',
    '&:last-child': {
      margin: `auto 0 ${theme.spaces[1]} auto`,
      alignItems: 'end',
      gap: theme.spaces[3]
    }
  };
},  true ? "" : 0);
const StyledSummaryItemLink = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1lnil220"
} : 0)( true ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : 0);
// EXTERNAL MODULE: ./src/shared/utils/jsx/index.ts + 3 modules
var jsx = __webpack_require__(62756);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/SummaryItem/SummaryItem.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const SummaryItem = /*#__PURE__*/(0,react.memo)(_ref => {
  var _images$, _images$2, _priceOutput$totalPri, _priceOutput$salePric, _priceOutput$salePric2, _priceOutput$unitPric, _priceOutput$totalPri2, _priceOutput$salePric3, _priceOutput$salePric4, _priceOutput$unitPric2;

  let {
    line
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    images,
    name,
    brand,
    productId,
    quantity = 1,
    priceOutput,
    url
  } = line;
  const separator = brand && productId ? ' - ' : '';
  const imageUrl = images && (images === null || images === void 0 ? void 0 : images.length) > 0 ? (0,utils/* generateImageUrl */.LJ)({
    size: 'productcarousel',
    fileName: ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.fileName) || '',
    modifiedDateTime: ((_images$2 = images[0]) === null || _images$2 === void 0 ? void 0 : _images$2.modifiedDateTime) || ''
  }) : undefined;
  const imageSize = {
    height: 76,
    width: 62
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSummaryItem, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx/* ConditionalWrap */.Qy, {
      if: Boolean(url),
      wrap: children => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: url || '',
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSummaryItemLink, {
          children: children
        })
      }),
      children: imageUrl ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, _objectSpread(_objectSpread({
        src: imageUrl
      }, imageSize), {}, {
        layout: "intrinsic",
        objectFit: "contain"
      })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SkeletonDeprecated */.yM, _objectSpread({}, imageSize))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSummaryContent, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx/* ConditionalWrap */.Qy, {
        if: Boolean(url),
        wrap: children => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: url || '',
          passHref: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSummaryItemLink, {
            children: children
          })
        }),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          children: name,
          variant: "body"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "caption",
        children: `${brand ? brand : ''}${separator}${productId ? productId : ''}`
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        children: translate('commerce.basket.quantityDescribed', [{
          key: 'quantity',
          value: quantity
        }]),
        variant: "caption"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx/* Visibility.HiddenFrom */.EE.HiddenFrom, {
        md: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* PriceGroup */.NO, {
          displayPriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$totalPri = priceOutput.totalPrice) === null || _priceOutput$totalPri === void 0 ? void 0 : _priceOutput$totalPri.displayTaxedPrice,
          displaySalePriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric = priceOutput.salePrice) === null || _priceOutput$salePric === void 0 ? void 0 : _priceOutput$salePric.displayTaxedPrice,
          displayUnitPriceInclTax: priceOutput !== null && priceOutput !== void 0 && priceOutput.salePrice ? priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric2 = priceOutput.salePrice) === null || _priceOutput$salePric2 === void 0 ? void 0 : _priceOutput$salePric2.displayTaxedPrice : priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$unitPric = priceOutput.unitPrice) === null || _priceOutput$unitPric === void 0 ? void 0 : _priceOutput$unitPric.displayTaxedPrice,
          isOnSale: (priceOutput === null || priceOutput === void 0 ? void 0 : priceOutput.salePrice) !== null,
          variant: "body"
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSummaryContent, {
      justifySelf: "flex-end",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx/* Visibility.VisibleFrom */.EE.VisibleFrom, {
        md: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* PriceGroup */.NO, {
          displayPriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$totalPri2 = priceOutput.totalPrice) === null || _priceOutput$totalPri2 === void 0 ? void 0 : _priceOutput$totalPri2.displayTaxedPrice,
          displaySalePriceInclTax: priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric3 = priceOutput.salePrice) === null || _priceOutput$salePric3 === void 0 ? void 0 : _priceOutput$salePric3.displayTaxedPrice,
          displayUnitPriceInclTax: priceOutput !== null && priceOutput !== void 0 && priceOutput.salePrice ? priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$salePric4 = priceOutput.salePrice) === null || _priceOutput$salePric4 === void 0 ? void 0 : _priceOutput$salePric4.displayTaxedPrice : priceOutput === null || priceOutput === void 0 ? void 0 : (_priceOutput$unitPric2 = priceOutput.unitPrice) === null || _priceOutput$unitPric2 === void 0 ? void 0 : _priceOutput$unitPric2.displayTaxedPrice,
          isOnSale: (priceOutput === null || priceOutput === void 0 ? void 0 : priceOutput.salePrice) !== null,
          variant: "body",
          orientation: "vertical"
        })
      })
    })]
  });
});
// EXTERNAL MODULE: ./src/components/features/Basket/components/FilterList/FilterList.module.css
var FilterList_module = __webpack_require__(31787);
var FilterList_module_default = /*#__PURE__*/__webpack_require__.n(FilterList_module);
;// CONCATENATED MODULE: ./src/components/features/Basket/components/FilterList/FilterList.tsx







let filtersEnum;

(function (filtersEnum) {
  filtersEnum["OutOfStock"] = "0";
  filtersEnum["ExpectedDate"] = "3";
})(filtersEnum || (filtersEnum = {}));

const FilterList = Props => {
  var _basket$lines, _basket$lines2;

  const {
    data: basket
  } = (0,hooks/* useBasket */.Kc)();
  const {
    0: selectedValue,
    1: setSelectedValue
  } = (0,react.useState)(null);
  const translate = (0,cms/* useTranslations */.T_)();
  var outOfStockCount = basket === null || basket === void 0 ? void 0 : (_basket$lines = basket.lines) === null || _basket$lines === void 0 ? void 0 : _basket$lines.filter(line => line.trafficLight == filtersEnum.OutOfStock).length;
  var expectedDateCount = basket === null || basket === void 0 ? void 0 : (_basket$lines2 = basket.lines) === null || _basket$lines2 === void 0 ? void 0 : _basket$lines2.filter(line => line.trafficLight == filtersEnum.ExpectedDate).length;

  const onFilterChange = selectedFilter => {
    var _Props$onFilter;

    if (selectedValue == selectedFilter) {
      setSelectedValue(null);
    } else {
      setSelectedValue(selectedFilter);
    }

    (_Props$onFilter = Props.onFilter) === null || _Props$onFilter === void 0 ? void 0 : _Props$onFilter.call(Props, selectedFilter);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (FilterList_module_default()).filterContainer,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Button */.zx, {
      className: (0,clsx_m/* default */.Z)((FilterList_module_default()).filterBtn, {
        [(FilterList_module_default()).selected]: selectedValue === filtersEnum.OutOfStock
      }),
      variant: selectedValue === filtersEnum.OutOfStock ? 'primary' : 'secondary',
      onClick: () => onFilterChange(filtersEnum.OutOfStock),
      children: [translate('commerce.basket.filter.outOfStock'), ": ", outOfStockCount]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Button */.zx, {
      className: (0,clsx_m/* default */.Z)((FilterList_module_default()).filterBtn, {
        [(FilterList_module_default()).selected]: selectedValue === filtersEnum.ExpectedDate
      }),
      variant: selectedValue === filtersEnum.ExpectedDate ? 'primary' : 'secondary',
      onClick: () => onFilterChange(filtersEnum.ExpectedDate),
      children: [translate('commerce.basket.filter.expectedDate'), ": ", expectedDateCount]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/Basket/components/index.ts







;// CONCATENATED MODULE: ./src/components/features/Basket/index.ts
/** Hook(s) */

/** Utils */




/***/ }),

/***/ 87669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jX": function() { return /* reexport */ addItem; },
  "$G": function() { return /* reexport */ updateItem; },
  "JT": function() { return /* reexport */ updateShipping; }
});

// UNUSED EXPORTS: removeItem

// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
;// CONCATENATED MODULE: ./src/components/features/Basket/service/add-item.ts

async function addItem(_ref, apiUrl, token) {
  let {
    productId,
    quantity
  } = _ref;
  const request = await (0,utils/* postRequest */.j0)(apiUrl, {
    productId,
    quantity
  }, {
    'Authorization': `Bearer ${token}`
  });
  const response = await request();
  return response;
}
;// CONCATENATED MODULE: ./src/components/features/Basket/service/update-item.ts

async function updateItem(variantId, quantity, apiUrl, token) {
  const request = quantity <= 0 ? await (0,utils/* deleteRequest */.Jl)(apiUrl, {
    variantId,
    quantity: 0
  }, {
    'Authorization': `Bearer ${token}`
  }) : await (0,utils/* putRequest */.GH)(apiUrl, {
    variantId,
    quantity
  }, {
    'Authorization': `Bearer ${token}`
  });
  const response = await request();
  return response;
}
;// CONCATENATED MODULE: ./src/components/features/Basket/service/remove-item.ts

async function removeItem(variantId, apiUrl, token) {
  const request = await deleteRequest(apiUrl, {
    variantId
  }, {
    'Authorization': `Bearer ${token}`
  });
  const response = await request();
  return response;
}
;// CONCATENATED MODULE: ./src/components/features/Basket/service/update-shipping.ts

async function updateShipping(args, apiUrl, token) {
  const request = await (0,utils/* postRequest */.j0)(apiUrl, args, {
    'Authorization': `Bearer ${token}`
  });
  const response = await request();
  return response;
}
;// CONCATENATED MODULE: ./src/components/features/Basket/service/index.ts





/***/ }),

/***/ 53279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ errorToJson; }
/* harmony export */ });
/**
 * Format error response to json
 *
 * @param error
 */
const errorToJson = async error => {
  const isReadableError = error.body && !error.bodyUsed;

  if (!isReadableError) {
    console.error(error);
    return {
      level: 'error',
      errorMessages: []
    };
  }

  const errorResponse = await error.json();
  return errorResponse;
};

/***/ }),

/***/ 9223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94965);
/* harmony import */ var _shared_hooks_useNotification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78560);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76345);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41377);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55060);







const DownloadCustomerPrices = _ref => {
  let {
    fileName
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
  const {
    catalogueBaseUrl
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .usePrefixUrl */ .Yp)();
  const {
    push
  } = (0,_shared_hooks_useNotification__WEBPACK_IMPORTED_MODULE_2__/* .useNotification */ .l)();
  const {
    session
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAuthentication */ .JL)();
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);

  function formatDate(timestamp) {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript

    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const url = `${catalogueBaseUrl}/priceslist`;

  const getPrices = async () => {
    setIsLoading(true);

    try {
      const res = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
      const data = await res.blob();
      var blob = new Blob([data]);
      if ((blob === null || blob === void 0 ? void 0 : blob.size) === 0) return push({
        severity: 'warning',
        text: translate('common.upsSomethingWentWrong')
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${(fileName === null || fileName === void 0 ? void 0 : fileName.replace(/ /g, '-')) || 'download'}-${formatDate(Date.now())}.xlsx`;
      link.target = '_blank';
      link.click();
    } catch (error) {
      push({
        severity: 'warning',
        text: translate('common.upsSomethingWentWrong')
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
    onClick: getPrices,
    variant: "secondary",
    isLoading: isLoading,
    children: "Download Price List"
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DownloadCustomerPrices);

/***/ }),

/***/ 83509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41377);
/* harmony import */ var _hooks_use_favorites__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84958);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94965);
/* harmony import */ var _AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55601);
/* harmony import */ var _AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76345);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14517);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55060);










const AddFavoriteButton = _ref => {
  let {
    productId,
    hideText,
    className
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_3__/* .useTranslations */ .T_)();
  const {
    isInTheList,
    favoritesMutation
  } = (0,_hooks_use_favorites__WEBPACK_IMPORTED_MODULE_2__/* .useFavorites */ .r)();
  const {
    isAuthenticated
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAuthentication */ .JL)();
  const isSelected = isInTheList(productId);
  const isFetching = favoritesMutation === null || favoritesMutation === void 0 ? void 0 : favoritesMutation.isLoading;

  if (!isAuthenticated) {
    return null;
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("button", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default().button), className),
    disabled: isFetching,
    onClick: () => favoritesMutation.mutate(productId),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
      className: (_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default().iconWrapper),
      children: [isFetching && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aN, {
        className: (_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default().loader),
        padding: "0",
        size: "26px",
        borderWidth: "2px"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .SvgIcon */ .le, {
        name: "star",
        className: isSelected ? (_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default().iconSelected) : (_AddFavoriteButton_module_css__WEBPACK_IMPORTED_MODULE_7___default().icon)
      })]
    }), !hideText && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
      variant: "bodySmall",
      color: "natural700Color",
      children: isSelected ? translate('favorites.removeFromFavorites') : translate('favorites.addAsFavorite')
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AddFavoriteButton);

/***/ }),

/***/ 84580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92072);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_shared_BaseProductInfo_BaseProductInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39169);
/* harmony import */ var _FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67116);
/* harmony import */ var _FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Basket_components_AddToBasket_AddToBasket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33830);
/* harmony import */ var _AddFavoriteButton_AddFavoriteButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83509);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64160);
/* harmony import */ var _components_features__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55060);



 // import { useTranslations } from '~/services/cms';








const FavoriteCard = _ref => {
  let {
    item
  } = _ref;
  // const translate = useTranslations()
  const {
    productId,
    name,
    jpGroupNumber,
    oldJPGroupNumber,
    packingUnit,
    // displayPrice,
    stock,
    trafficLight
  } = item;
  const PDPLink = (0,_shared_utils__WEBPACK_IMPORTED_MODULE_5__/* .generatePDPLink */ .wP)({
    productId,
    variantId: productId,
    displayName: name || 'product'
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
    className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().root),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().baseProductInfo),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        passHref: true,
        "aria-label": name,
        title: name,
        href: PDPLink,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
          href: PDPLink,
          className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().productLink),
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_shared_BaseProductInfo_BaseProductInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            imgSrc: item === null || item === void 0 ? void 0 : item.image,
            productName: name,
            jpGroupNumber: jpGroupNumber,
            oeNumber: oldJPGroupNumber
          })
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().stockStatus),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_features__WEBPACK_IMPORTED_MODULE_6__/* .StockStatus */ .BQ, {
        statusCode: trafficLight,
        productId: productId,
        amount: stock
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().price),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_features__WEBPACK_IMPORTED_MODULE_6__/* .CustomerPrice */ .VA, {
        variantId: productId,
        packingUnit: packingUnit || 1 // unit={data?.Unit?.value}

      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().addToBasket),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Basket_components_AddToBasket_AddToBasket__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        small: true,
        productId: productId,
        variantId: productId,
        colli: Number(packingUnit || 1),
        hideButtonText: true
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_FavoriteCard_module_css__WEBPACK_IMPORTED_MODULE_8___default().addFavorite),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_AddFavoriteButton_AddFavoriteButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        productId: productId,
        hideText: true
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FavoriteCard);

/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFavorites; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12445);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31781);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72603);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53083);
/* harmony import */ var _shared_hooks_useNotification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78560);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76345);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const useFavorites = () => {
  const {
    push
  } = (0,_shared_hooks_useNotification__WEBPACK_IMPORTED_MODULE_1__/* .useNotification */ .l)();
  const {
    favoritesBaseUrl
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .usePrefixUrl */ .Yp)();
  const {
    isAuthenticated,
    session
  } = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useAuthentication */ .JL)();
  const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQueryClient */ .NL)();
  const {
    isLoading,
    isError,
    data
  } = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
    refetchOnWindowFocus: true,
    queryKey: ['favorites'],
    enabled: isAuthenticated,
    queryFn: async () => {
      const res = await fetch(favoritesBaseUrl, {
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
      const json = await res.json();
      return _objectSpread(_objectSpread({}, json), {}, {
        statusCode: res.status
      });
    }
  });

  function isInTheList(itemId) {
    var _data$items;

    return Boolean(data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.find(f => f.productId === itemId));
  }

  const favoritesMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)({
    mutationFn: async id => {
      const isSelected = isInTheList(id);
      const res = await fetch(`${favoritesBaseUrl}/line/${id}`, {
        method: isSelected ? 'DELETE' : 'POST',
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
      return await res.json();
    },
    onError: err => {
      console.log('err', err);
      push({
        severity: 'warning',
        text: 'Could add to favorites!!!'
      });
    },
    onSuccess: data => {
      queryClient.setQueryData(['favorites'], data);
    }
  });
  return {
    favoritesMutation,
    data,
    isLoading,
    isError,
    isInTheList
  };
};

/***/ }),

/***/ 18603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41377);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55060);






const PriceOffers = _ref => {
  let {
    values = []
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_2__/* .useTranslations */ .T_)();
  if (!values || values.length === 0) return null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
    children: values.map((val, index) => {
      var _val$minimumQuantity, _val$priceToDisplay;

      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
        variant: "bodyExtraSmall",
        color: "natural700Color",
        children: translate('product.priceOffers').replace('[minimumQuantity]', (val === null || val === void 0 ? void 0 : (_val$minimumQuantity = val.minimumQuantity) === null || _val$minimumQuantity === void 0 ? void 0 : _val$minimumQuantity.toString()) || '').replace('[priceToDisplay]', (val === null || val === void 0 ? void 0 : (_val$priceToDisplay = val.priceToDisplay) === null || _val$priceToDisplay === void 0 ? void 0 : _val$priceToDisplay.toString()) || '')
      }, index);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceOffers);

/***/ }),

/***/ 71243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ActiveFacets; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41377);
/* harmony import */ var _use_facets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94567);
/* harmony import */ var _ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45122);
/* harmony import */ var _ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55060);







const ActiveFacets = _ref => {
  var _relewiseFacets$items, _activeFacets$filter;

  let {
    relewiseFacets,
    isFetching,
    isPLP,
    isMobile
  } = _ref;
  const {
    activeFacets,
    setFacet,
    setCategoryHierarchyFacet,
    clearFacets
  } = (0,_use_facets__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)();
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_3__/* .useTranslations */ .T_)();
  const {
    data: frameData
  } = (0,_services_cms__WEBPACK_IMPORTED_MODULE_3__/* .useFrame */ .xQ)();
  const staticLinks = frameData === null || frameData === void 0 ? void 0 : frameData.staticLinks;

  const mapDataObjectStringValueFacet = item => {
    var _item$available, _item$available$filte;

    const getDisplayname = function () {
      let val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (typeof val === 'string') return val;

      if (typeof val === 'boolean') {
        if ((item === null || item === void 0 ? void 0 : item.key) === 'IsClassic') {
          return val ? translate('facets.isClassicVehicle') : translate('facets.isNotClassicVehicle');
        } else {
          return `${item === null || item === void 0 ? void 0 : item.key} ${val ? 'True' : 'False'}`;
        }
      }

      return '';
    };

    return (item === null || item === void 0 ? void 0 : (_item$available = item.available) === null || _item$available === void 0 ? void 0 : (_item$available$filte = _item$available.filter(f => Boolean(activeFacets.find(a => {
      var _f$value;

      return ((_f$value = f.value) === null || _f$value === void 0 ? void 0 : _f$value.toString()) && a.values.includes(f.value.toString());
    })))) === null || _item$available$filte === void 0 ? void 0 : _item$available$filte.map(f => {
      return {
        hits: f.hits || 0,
        facetKey: (item === null || item === void 0 ? void 0 : item.key) || '',
        facetValue: f.value || '',
        displayName: getDisplayname(f === null || f === void 0 ? void 0 : f.value),
        isCategoryHierarchyFacet: false
      };
    })) || [];
  };

  const mapCategoryHierarchyFacet = item => {
    var _nodes;

    const selectedNodes = (item === null || item === void 0 ? void 0 : (_nodes = item.nodes) === null || _nodes === void 0 ? void 0 : _nodes.filter(f => f === null || f === void 0 ? void 0 : f.selected)) || [];
    const selectedCategories = (selectedNodes === null || selectedNodes === void 0 ? void 0 : selectedNodes.map(c => c === null || c === void 0 ? void 0 : c.children).flat().filter(f => f === null || f === void 0 ? void 0 : f.selected)) || [];
    return (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories.map(f => {
      var _f$category, _f$category2;

      return {
        hits: (f === null || f === void 0 ? void 0 : f.hits) || 0,
        parentId: (f === null || f === void 0 ? void 0 : f.parentId) || '',
        childId: (f === null || f === void 0 ? void 0 : (_f$category = f.category) === null || _f$category === void 0 ? void 0 : _f$category.categoryId) || '',
        displayName: (f === null || f === void 0 ? void 0 : (_f$category2 = f.category) === null || _f$category2 === void 0 ? void 0 : _f$category2.displayName) || '',
        isCategoryHierarchyFacet: true
      };
    })) || [];
  };

  const flatFacets = (relewiseFacets === null || relewiseFacets === void 0 ? void 0 : (_relewiseFacets$items = relewiseFacets.items) === null || _relewiseFacets$items === void 0 ? void 0 : _relewiseFacets$items.map(item => {
    if ((item === null || item === void 0 ? void 0 : item.field) === 'Brand' || (item === null || item === void 0 ? void 0 : item.field) === 'Category' && item !== null && item !== void 0 && item.$type.includes('CategoryFacet')) {
      var _available;

      const filteredFacet = item === null || item === void 0 ? void 0 : (_available = item.available) === null || _available === void 0 ? void 0 : _available.filter(f => f.selected);
      return filteredFacet === null || filteredFacet === void 0 ? void 0 : filteredFacet.map(f => {
        var _f$value2, _f$value3;

        return {
          hits: f.hits,
          facetKey: item === null || item === void 0 ? void 0 : item.field,
          facetValue: (_f$value2 = f.value) === null || _f$value2 === void 0 ? void 0 : _f$value2.id,
          displayName: f === null || f === void 0 ? void 0 : (_f$value3 = f.value) === null || _f$value3 === void 0 ? void 0 : _f$value3.displayName
        };
      });
    }

    if ((item === null || item === void 0 ? void 0 : item.field) === 'Category' && item !== null && item !== void 0 && item.$type.includes('CategoryHierarchyFacet')) {
      return isMobile ? mapCategoryHierarchyFacet(item) : undefined;
    }

    if ((item === null || item === void 0 ? void 0 : item.field) === 'Data') {
      const facetData = item;

      if ((facetData === null || facetData === void 0 ? void 0 : facetData.key) === 'Remark') {
        const innerFacetData = item;
        return mapDataObjectStringValueFacet(innerFacetData);
      }

      if ((facetData === null || facetData === void 0 ? void 0 : facetData.key) === 'Linkages') {
        var _items, _items$filter;

        return item === null || item === void 0 ? void 0 : (_items = item.items) === null || _items === void 0 ? void 0 : (_items$filter = _items.filter(f => Boolean(activeFacets.find(a => a.key === (f === null || f === void 0 ? void 0 : f.key))))) === null || _items$filter === void 0 ? void 0 : _items$filter.map(f => mapDataObjectStringValueFacet(f)).flat();
      }
    } //@ts-ignore

  }).flat().filter(facet => facet !== undefined)) || [];
  if (!((_activeFacets$filter = activeFacets.filter(f => f.key !== "CategoryHierarchy")) !== null && _activeFacets$filter !== void 0 && _activeFacets$filter.length) && !isPLP) return null;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().root),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
      className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().facetsWrapper),
      children: [flatFacets === null || flatFacets === void 0 ? void 0 : flatFacets.map((f, i) => {
        if (f !== null && f !== void 0 && f.isCategoryHierarchyFacet) {
          const facet = f;
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
            className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().buttonWrapper),
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
              iconName: "close",
              iconPosition: "right",
              variant: "tertiary",
              size: "small",
              onClick: () => setCategoryHierarchyFacet(facet === null || facet === void 0 ? void 0 : facet.parentId, facet === null || facet === void 0 ? void 0 : facet.childId),
              children: [facet === null || facet === void 0 ? void 0 : facet.displayName, " (", facet === null || facet === void 0 ? void 0 : facet.hits, ")"]
            }, `${facet === null || facet === void 0 ? void 0 : facet.parentId}-${facet === null || facet === void 0 ? void 0 : facet.childId}-${i}`), isFetching && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .Od, {
              width: "100%",
              height: "100%",
              className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().skeleton),
              variant: "darker"
            })]
          });
        }

        const facet = f;
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
          className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().buttonWrapper),
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
            iconName: "close",
            iconPosition: "right",
            variant: "tertiary",
            size: "small",
            onClick: () => setFacet(facet === null || facet === void 0 ? void 0 : facet.facetKey, facet === null || facet === void 0 ? void 0 : facet.facetValue),
            children: [facet === null || facet === void 0 ? void 0 : facet.displayName, " (", facet === null || facet === void 0 ? void 0 : facet.hits, ")"]
          }, `${facet === null || facet === void 0 ? void 0 : facet.facetKey}-${facet === null || facet === void 0 ? void 0 : facet.facetValue}-${i}`), isFetching && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .Od, {
            width: "100%",
            height: "100%",
            className: (_ActiveFacets_module_css__WEBPACK_IMPORTED_MODULE_5___default().skeleton),
            variant: "darker"
          })]
        });
      }), (activeFacets === null || activeFacets === void 0 ? void 0 : activeFacets.length) > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
        size: "small",
        onClick: () => clearFacets(),
        disabled: isFetching,
        children: translate('facets.clearAllFilter')
      }) : null]
    }), (staticLinks === null || staticLinks === void 0 ? void 0 : staticLinks.allProductsPage) && isPLP && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
      size: "small",
      href: staticLinks.allProductsPage.url,
      children: staticLinks.allProductsPage.title
    })]
  });
};

/***/ }),

/***/ 32720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12445);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _ActiveFacets_ActiveFacets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71243);
/* harmony import */ var _FacetsFilter_FacetsFilter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28198);
/* harmony import */ var _Facets_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36308);
/* harmony import */ var _Facets_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Facets_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55060);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const Facets = props => {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    className: (_Facets_module_css__WEBPACK_IMPORTED_MODULE_5___default().root),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_FacetsFilter_FacetsFilter__WEBPACK_IMPORTED_MODULE_3__/* .FacetsFilter */ .b, _objectSpread({}, props)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_ActiveFacets_ActiveFacets__WEBPACK_IMPORTED_MODULE_2__/* .ActiveFacets */ .v, _objectSpread({}, props))]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Facets);

/***/ }),

/***/ 28198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FacetsFilter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41377);
/* harmony import */ var _components_features_ProductsList_Facets_use_facets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94567);
/* harmony import */ var _FacetsFilter_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91129);
/* harmony import */ var _FacetsFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_FacetsFilter_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55060);








const sortFacets = (a, b) => {
  let nameA = '';
  let nameB = '';

  if (typeof (a === null || a === void 0 ? void 0 : a.value) === 'object' && (a === null || a === void 0 ? void 0 : a.value) !== null && typeof (b === null || b === void 0 ? void 0 : b.value) === 'object' && (b === null || b === void 0 ? void 0 : b.value) !== null) {
    var _a$value, _a$value$displayName, _a$value$displayName$, _b$value, _b$value$displayName, _b$value$displayName$;

    nameA = (a === null || a === void 0 ? void 0 : (_a$value = a.value) === null || _a$value === void 0 ? void 0 : (_a$value$displayName = _a$value.displayName) === null || _a$value$displayName === void 0 ? void 0 : (_a$value$displayName$ = _a$value$displayName.toString()) === null || _a$value$displayName$ === void 0 ? void 0 : _a$value$displayName$.toUpperCase()) || '';
    nameB = (b === null || b === void 0 ? void 0 : (_b$value = b.value) === null || _b$value === void 0 ? void 0 : (_b$value$displayName = _b$value.displayName) === null || _b$value$displayName === void 0 ? void 0 : (_b$value$displayName$ = _b$value$displayName.toString()) === null || _b$value$displayName$ === void 0 ? void 0 : _b$value$displayName$.toUpperCase()) || '';
  } else {
    var _a$value2, _a$value2$toString, _b$value2, _b$value2$toString;

    nameA = (a === null || a === void 0 ? void 0 : (_a$value2 = a.value) === null || _a$value2 === void 0 ? void 0 : (_a$value2$toString = _a$value2.toString()) === null || _a$value2$toString === void 0 ? void 0 : _a$value2$toString.toUpperCase()) || '';
    nameB = (b === null || b === void 0 ? void 0 : (_b$value2 = b.value) === null || _b$value2 === void 0 ? void 0 : (_b$value2$toString = _b$value2.toString()) === null || _b$value2$toString === void 0 ? void 0 : _b$value2$toString.toUpperCase()) || '';
  }

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  } // names must be equal


  return 0;
};

const linkagesFacetsToHideOnMobile = ['BodyType', 'FuelType'];
const FacetsFilter = _ref => {
  var _relewiseFacets$items, _relewiseFacets$items2, _brandFacet$available, _dataObjectFacets$fin, _remarkFacet$availabl, _remarkFacet$availabl2, _remarkFacet$availabl3, _brandFacet$available2, _brandFacet$available3, _newMonthFacet$availa, _newMonthFacet$availa2, _newMonthFacet$availa3;

  let {
    relewiseFacets,
    isFetching,
    isLoading,
    isMobile
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_3__/* .useTranslations */ .T_)();
  const {
    activeFacets,
    setFacet
  } = (0,_components_features_ProductsList_Facets_use_facets__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)();

  const isActive = (field, value) => {
    const selectedFiled = activeFacets.find(af => {
      var _af$key;

      return ((_af$key = af.key) === null || _af$key === void 0 ? void 0 : _af$key.toString()) === (field === null || field === void 0 ? void 0 : field.toString());
    });

    if (selectedFiled) {
      return selectedFiled === null || selectedFiled === void 0 ? void 0 : selectedFiled.values.some(sf => (sf === null || sf === void 0 ? void 0 : sf.toString()) === (value === null || value === void 0 ? void 0 : value.toString()));
    }

    return false;
  };

  if (isLoading) return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    className: (_FacetsFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().root),
    children: Array.from(Array(9).keys()).map(item => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .Skeleton */ .Od, {
      width: "100%",
      height: "50px"
    }, item))
  });
  if (!relewiseFacets) return null;
  const dataObjectFacets = (relewiseFacets === null || relewiseFacets === void 0 ? void 0 : (_relewiseFacets$items = relewiseFacets.items) === null || _relewiseFacets$items === void 0 ? void 0 : _relewiseFacets$items.filter(f => f.field === 'Data')) || [];
  const brandFacet = (relewiseFacets === null || relewiseFacets === void 0 ? void 0 : (_relewiseFacets$items2 = relewiseFacets.items) === null || _relewiseFacets$items2 === void 0 ? void 0 : _relewiseFacets$items2.find(f => f.field === 'Brand')) || null;
  const brandAvailableOrdered = brandFacet !== null ? brandFacet === null || brandFacet === void 0 ? void 0 : (_brandFacet$available = brandFacet.available) === null || _brandFacet$available === void 0 ? void 0 : _brandFacet$available.sort((a, b) => {
    var _a$value3, _b$value3, _a$value4, _b$value4, _a$value5, _b$value5;

    if (!(a !== null && a !== void 0 && (_a$value3 = a.value) !== null && _a$value3 !== void 0 && _a$value3.displayName) || !(b !== null && b !== void 0 && (_b$value3 = b.value) !== null && _b$value3 !== void 0 && _b$value3.displayName)) return 0;

    if ((a === null || a === void 0 ? void 0 : (_a$value4 = a.value) === null || _a$value4 === void 0 ? void 0 : _a$value4.displayName) < (b === null || b === void 0 ? void 0 : (_b$value4 = b.value) === null || _b$value4 === void 0 ? void 0 : _b$value4.displayName)) {
      return -1;
    }

    if ((a === null || a === void 0 ? void 0 : (_a$value5 = a.value) === null || _a$value5 === void 0 ? void 0 : _a$value5.displayName) > (b === null || b === void 0 ? void 0 : (_b$value5 = b.value) === null || _b$value5 === void 0 ? void 0 : _b$value5.displayName)) {
      return 1;
    }

    return 0;
  }) : null;
  brandFacet.available = brandAvailableOrdered; // const categoryFacet = relewiseFacets?.items?.find(f => f.field === 'Category') as CategoryFacetResult || null
  // dataFacets

  const remarkFacet = dataObjectFacets.find(f => f.key === 'Remark') || null;
  const newMonthFacet = dataObjectFacets.find(f => f.key === 'NewMonth') || null; // linkagesFacets

  const linkagesFacets = ((_dataObjectFacets$fin = dataObjectFacets.find(f => f.key === 'Linkages')) === null || _dataObjectFacets$fin === void 0 ? void 0 : _dataObjectFacets$fin.items) || []; // In case we need ot hardcode the order of the linkagesFacets
  // const vehicleManufacturerFacets = linkagesFacets?.find(f => f.key === 'Manufacturer') as DataObjectStringValueFacetResult || null
  // const vehicleTypeFacets = linkagesFacets?.find(f => f.key === 'VehicleType') as DataObjectStringValueFacetResult || null
  // const vehicleModelSeriesFacets = linkagesFacets?.find(f => f.key === 'ModelSeries') as DataObjectStringValueFacetResult || null
  // const vehicleFuelTypeFacets = linkagesFacets?.find(f => f.key === 'FuelType') as DataObjectStringValueFacetResult || null
  // const vehicleProductionYearsFacets = linkagesFacets?.find(f => f.key === 'ProductionYears') as DataObjectStringValueFacetResult || null

  const getLabelName = function () {
    let facetKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (typeof value === 'string') {
      return value || '';
    } else if (typeof value === 'boolean') {
      // Handle different boolean case values
      // at the moment we have only 'IsClassic'
      switch (facetKey) {
        case 'IsClassic':
          return value ? translate('facets.isClassicVehicle') : translate('facets.isNotClassicVehicle');

        default:
          return value ? 'True' : 'False';
      }
    }

    return '';
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    className: (_FacetsFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().root),
    children: [linkagesFacets === null || linkagesFacets === void 0 ? void 0 : linkagesFacets.map(linkagesFacet => {
      var _linkagesFacet$availa, _linkagesFacet$availa2, _linkagesFacet$availa3;

      const facetKey = linkagesFacet === null || linkagesFacet === void 0 ? void 0 : linkagesFacet.key;
      const shouldHideOnMobile = isMobile && linkagesFacetsToHideOnMobile.includes(facetKey);
      if (shouldHideOnMobile || !(linkagesFacet !== null && linkagesFacet !== void 0 && (_linkagesFacet$availa = linkagesFacet.available) !== null && _linkagesFacet$availa !== void 0 && _linkagesFacet$availa.length)) return null;
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelector */ .u9, {
        label: translate(`facets.linkages${facetKey}`),
        isFetching: isFetching,
        children: linkagesFacet === null || linkagesFacet === void 0 ? void 0 : (_linkagesFacet$availa2 = linkagesFacet.available) === null || _linkagesFacet$availa2 === void 0 ? void 0 : (_linkagesFacet$availa3 = _linkagesFacet$availa2.sort(sortFacets)) === null || _linkagesFacet$availa3 === void 0 ? void 0 : _linkagesFacet$availa3.map((f, i) => {
          var _f$value;

          const facetValueAsString = f === null || f === void 0 ? void 0 : (_f$value = f.value) === null || _f$value === void 0 ? void 0 : _f$value.toString();
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelectorOption */ .rM, {
            disabled: isFetching || !(f !== null && f !== void 0 && f.hits),
            label: getLabelName(facetKey, f === null || f === void 0 ? void 0 : f.value),
            secondaryText: `(${f === null || f === void 0 ? void 0 : f.hits})`,
            onClick: () => setFacet(facetKey, facetValueAsString),
            isSelected: isActive(facetKey, facetValueAsString)
          }, `${facetValueAsString}-${i}`);
        })
      }, facetKey);
    }), remarkFacet !== null && remarkFacet !== void 0 && (_remarkFacet$availabl = remarkFacet.available) !== null && _remarkFacet$availabl !== void 0 && _remarkFacet$availabl.length ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelector */ .u9, {
      label: remarkFacet === null || remarkFacet === void 0 ? void 0 : remarkFacet.key,
      isFetching: isFetching,
      children: remarkFacet === null || remarkFacet === void 0 ? void 0 : (_remarkFacet$availabl2 = remarkFacet.available) === null || _remarkFacet$availabl2 === void 0 ? void 0 : (_remarkFacet$availabl3 = _remarkFacet$availabl2.sort(sortFacets)) === null || _remarkFacet$availabl3 === void 0 ? void 0 : _remarkFacet$availabl3.map((f, i) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelectorOption */ .rM, {
        disabled: isFetching || !(f !== null && f !== void 0 && f.hits),
        label: f === null || f === void 0 ? void 0 : f.value,
        secondaryText: `(${f === null || f === void 0 ? void 0 : f.hits})`,
        onClick: () => setFacet(remarkFacet === null || remarkFacet === void 0 ? void 0 : remarkFacet.key, f === null || f === void 0 ? void 0 : f.value),
        isSelected: isActive(remarkFacet === null || remarkFacet === void 0 ? void 0 : remarkFacet.key, f === null || f === void 0 ? void 0 : f.value)
      }, `${f === null || f === void 0 ? void 0 : f.value}-${i}`))
    }) : null, brandFacet !== null && brandFacet !== void 0 && (_brandFacet$available2 = brandFacet.available) !== null && _brandFacet$available2 !== void 0 && _brandFacet$available2.length && !isMobile ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelector */ .u9, {
      label: translate('facets.brand'),
      isFetching: isFetching,
      children: brandFacet === null || brandFacet === void 0 ? void 0 : (_brandFacet$available3 = brandFacet.available) === null || _brandFacet$available3 === void 0 ? void 0 : _brandFacet$available3.map((f, i) => {
        var _f$value2, _f$value3, _f$value5;

        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelectorOption */ .rM, {
          disabled: isFetching || !(f !== null && f !== void 0 && f.hits),
          label: f === null || f === void 0 ? void 0 : (_f$value3 = f.value) === null || _f$value3 === void 0 ? void 0 : _f$value3.displayName,
          secondaryText: `(${f === null || f === void 0 ? void 0 : f.hits})`,
          onClick: () => {
            var _f$value4;

            return setFacet(brandFacet === null || brandFacet === void 0 ? void 0 : brandFacet.field, f === null || f === void 0 ? void 0 : (_f$value4 = f.value) === null || _f$value4 === void 0 ? void 0 : _f$value4.id);
          },
          isSelected: isActive(brandFacet === null || brandFacet === void 0 ? void 0 : brandFacet.field, f === null || f === void 0 ? void 0 : (_f$value5 = f.value) === null || _f$value5 === void 0 ? void 0 : _f$value5.id)
        }, `${f === null || f === void 0 ? void 0 : (_f$value2 = f.value) === null || _f$value2 === void 0 ? void 0 : _f$value2.id}-${i}`);
      })
    }) : null, newMonthFacet !== null && newMonthFacet !== void 0 && (_newMonthFacet$availa = newMonthFacet.available) !== null && _newMonthFacet$availa !== void 0 && _newMonthFacet$availa.length ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelector */ .u9, {
      label: translate('facets.newMonth.title'),
      isFetching: isFetching,
      children: newMonthFacet === null || newMonthFacet === void 0 ? void 0 : (_newMonthFacet$availa2 = newMonthFacet.available) === null || _newMonthFacet$availa2 === void 0 ? void 0 : (_newMonthFacet$availa3 = _newMonthFacet$availa2.sort(sortFacets)) === null || _newMonthFacet$availa3 === void 0 ? void 0 : _newMonthFacet$availa3.map((f, i) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .MultipleSelectorOption */ .rM, {
        disabled: isFetching || !(f !== null && f !== void 0 && f.hits),
        label: translate(`newMonth.month${f.value}`),
        secondaryText: `(${f === null || f === void 0 ? void 0 : f.hits})`,
        onClick: () => setFacet(newMonthFacet === null || newMonthFacet === void 0 ? void 0 : newMonthFacet.key, f === null || f === void 0 ? void 0 : f.value),
        isSelected: isActive(newMonthFacet === null || newMonthFacet === void 0 ? void 0 : newMonthFacet.key, f === null || f === void 0 ? void 0 : f.value)
      }, `${f === null || f === void 0 ? void 0 : f.value}-${i}`))
    }) : null]
  });
};

/***/ }),

/***/ 94567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uB": function() { return /* binding */ getRouterQueryParamsWithoutPagination; }
/* harmony export */ });
/* unused harmony export facetQueryKeyPrefix */
/* harmony import */ var _home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12445);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38019);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77626);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_3__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_vsts_work_1_s_node_modules_pnpm_next_12_3_2_oszf7dt2qvdtfacaaz5ryqyqi4_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function getRouterQueryParamsWithoutPagination(routerParams) {
  // Copies the router params
  const copiedRouterParams = _objectSpread({}, routerParams); // Removes the slug from the params


  delete copiedRouterParams.slug; // Removes the page from the params

  delete copiedRouterParams.page;
  return copiedRouterParams;
} // Query string prefix used for all facet keys

const facetQueryKeyPrefix = 'f.';

const useFacets = () => {
  const {
    0: activeFacets,
    1: setActiveFacets
  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  const routerParams = getRouterQueryParamsWithoutPagination(router.query);

  function setMultipleFacets(payload) {
    let newRouterParams = _objectSpread({}, routerParams);

    payload.forEach(_ref => {
      let {
        facetKey,
        facetValue
      } = _ref;
      const facetQueryKey = `${facetQueryKeyPrefix}${facetKey}`;
      let values = routerParams[facetQueryKey] || [];

      if (!Array.isArray(values)) {
        values = [values];
      } // Add value or remove it if it already exists


      const existingValueIndex = values.findIndex(value => value === facetValue);

      if (existingValueIndex > -1) {
        values.splice(existingValueIndex, 1);
      } else {
        values.push(facetValue);
      }

      newRouterParams[facetQueryKey] = values; // Complete remove query param if no values left or no facetValue

      if (values.length === 0 || !facetValue) {
        delete newRouterParams[facetQueryKey];
      }
    });
    const hasHash = window.location.hash && window.location.hash.length > 0;
    const url = hasHash ? (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: newRouterParams,
      hash: window.location.hash
    }) : (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: newRouterParams
    });
    router.replace(url, undefined, {
      shallow: true,
      scroll: false
    });
  }

  function setFacet(facetKey, facetValue) {
    const facetQueryKey = `${facetQueryKeyPrefix}${facetKey}`;
    let values = routerParams[facetQueryKey] || [];

    if (!Array.isArray(values)) {
      values = [values];
    } // Add value or remove it if it already exists


    const existingValueIndex = values.findIndex(value => value === facetValue);

    if (existingValueIndex > -1) {
      values.splice(existingValueIndex, 1);
    } else {
      values.push(facetValue);
    }

    const queryParams = _objectSpread(_objectSpread({}, routerParams), {}, {
      [facetQueryKey]: values
    }); // Complete remove query param if no values left or no facetValue


    if (values.length === 0 || !facetValue) {
      delete queryParams[facetQueryKey];
    }

    const hasHash = window.location.hash && window.location.hash.length > 0;
    const url = hasHash ? (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: queryParams,
      hash: window.location.hash
    }) : (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: queryParams
    });
    router.replace(url, undefined, {
      shallow: true,
      scroll: false
    });
  }

  function getActiveFacets(query) {
    if (!query) return [];
    return Object.entries(routerParams).filter(param => param[0].startsWith(facetQueryKeyPrefix)).map(param => ({
      key: param[0].slice(2),
      values: Array.isArray(param[1]) ? param[1] : [param[1]]
    }));
  }

  function clearFacets(facets) {
    const copyOfRouterParams = _objectSpread({}, routerParams);

    if (facets) {
      facets === null || facets === void 0 ? void 0 : facets.forEach(facet => {
        delete copyOfRouterParams[`${facetQueryKeyPrefix}${facet}`];
      });
    } else {
      Object.keys(copyOfRouterParams).forEach(key => {
        if (!key.startsWith(facetQueryKeyPrefix)) return;
        delete copyOfRouterParams[key];
      });
    }

    const hasHash = window.location.hash && window.location.hash.length > 0;
    const url = hasHash ? (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: copyOfRouterParams,
      hash: window.location.hash
    }) : (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: copyOfRouterParams
    });
    router === null || router === void 0 ? void 0 : router.push(url, undefined, {
      shallow: true
    });
  }

  const setCategoryHierarchyFacet = (parentId, childId) => {
    const facetQueryKey = `${facetQueryKeyPrefix}CategoryHierarchy`;
    let values = routerParams[facetQueryKey] || [];

    if (!Array.isArray(values)) {
      values = [values];
    } // Add value or remove it if it already exists


    const existingValueIndex = values.findIndex(value => value === `${parentId}-${childId}`);

    if (existingValueIndex > -1) {
      values.splice(existingValueIndex, 1);
    } else {
      values.push(`${parentId}-${childId}`);
    }

    const queryParams = _objectSpread(_objectSpread({}, routerParams), {}, {
      [facetQueryKey]: values
    }); // Complete remove query param if no values left or no facetValue


    if (values.length === 0 || !parentId || !childId) {
      delete queryParams[facetQueryKey];
    }

    const hasHash = window.location.hash && window.location.hash.length > 0;
    const url = hasHash ? (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: queryParams,
      hash: window.location.hash
    }) : (0,url__WEBPACK_IMPORTED_MODULE_3__.format)({
      pathname: window.location.pathname,
      query: queryParams
    });
    router.replace(url, undefined, {
      shallow: true,
      scroll: false
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (!router.query) return;
    const facets = getActiveFacets(router.query);
    setActiveFacets(facets);
  }, [router]);
  const activeFacetsLength = activeFacets.map(f => f.values).flat().length;
  return {
    activeFacets,
    activeFacetsLength,
    setFacet,
    setMultipleFacets,
    setCategoryHierarchyFacet,
    clearFacets
  };
};

/* harmony default export */ __webpack_exports__["ZP"] = (useFacets);

/***/ }),

/***/ 67160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _Facets_Facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32720);
/* harmony import */ var _MobileFilters_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15850);
/* harmony import */ var _MobileFilters_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_MobileFilters_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41377);
/* harmony import */ var _Sorting_Sorting__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33692);
/* harmony import */ var _components_modules_M170SearchPage_components_SidebarFilter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32050);
/* harmony import */ var _Facets_use_facets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94567);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55060);












const MobileFilters = props => {
  const {
    relewiseFacets,
    sortBy = '',
    sortOrder = 'Ascending',
    onChangeOrder,
    onChangeSortBy,
    isFetching,
    isLoading,
    searchQuery,
    facets,
    isLicensePlateSearch
  } = props;
  const {
    0: isOpen,
    1: setOpen
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    activeFacetsLength
  } = (0,_Facets_use_facets__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)();
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_6__/* .useTranslations */ .T_)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, {
      open: isOpen,
      onDismiss: () => setOpen(false),
      variant: "full",
      text: translate('accessibility.closeIconTitle'),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        className: (_MobileFilters_module_scss__WEBPACK_IMPORTED_MODULE_8___default().filterRoot),
        children: [!isLicensePlateSearch && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
            variant: "body",
            children: translate('facets.filterOnCarModel')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
            size: "2"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Facets_Facets__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            relewiseFacets: relewiseFacets,
            isFetching: isFetching,
            isMobile: true
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
            size: "6"
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Sorting_Sorting__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          sortBy: sortBy,
          sortOrder: sortOrder,
          onChangeSortBy: onChangeSortBy,
          onChangeOrder: onChangeOrder,
          isFetching: isFetching
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .LZ, {
          size: "6"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_modules_M170SearchPage_components_SidebarFilter__WEBPACK_IMPORTED_MODULE_4__/* .SidebarFilter */ .Q, {
          isFetching: isFetching,
          isLoading: isLoading,
          searchQuery: searchQuery,
          facets: facets
        })]
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
      className: (_MobileFilters_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stickySection),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
        onClick: () => setOpen(true),
        size: "large",
        iconName: "filter",
        isFlexible: true,
        children: [translate('facets.filters'), activeFacetsLength ? ` (${activeFacetsLength} ${translate('facets.activeFacets')})` : '']
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MobileFilters);

/***/ }),

/***/ 33692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94965);
/* harmony import */ var _Sorting_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16408);
/* harmony import */ var _Sorting_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Sorting_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41377);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55060);







const Sorting = props => {
  const {
    sortBy = '',
    sortOrder = 'Ascending',
    onChangeOrder,
    onChangeSortBy,
    isFetching
  } = props;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
  const sortingOptions = [{
    label: translate('sorting.labelRelevance'),
    value: ''
  }, {
    label: translate('sorting.labelJpGroupNumber'),
    value: 'JpGroupNumber'
  }];
  const sortingOrderOptions = [{
    label: translate('sorting.ascending'),
    value: 'Ascending'
  }, {
    label: translate('sorting.descending'),
    value: 'Descending'
  }];
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
    className: (_Sorting_module_css__WEBPACK_IMPORTED_MODULE_4___default().root),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      variant: "bodySmall",
      children: translate('sorting.sortBy')
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
      className: (_Sorting_module_css__WEBPACK_IMPORTED_MODULE_4___default().controls),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("select", {
        className: (_Sorting_module_css__WEBPACK_IMPORTED_MODULE_4___default().select),
        disabled: isFetching,
        value: sortBy,
        onChange: e => onChangeSortBy(e.target.value),
        children: sortingOptions.map(option => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("option", {
          value: option.value,
          children: option.label
        }, option.value))
      }), sortBy && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("select", {
        className: (_Sorting_module_css__WEBPACK_IMPORTED_MODULE_4___default().select),
        disabled: isFetching,
        value: sortOrder,
        onChange: e => onChangeOrder(e.target.value),
        children: sortingOrderOptions.map(option => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("option", {
          value: option.value,
          children: option.label
        }, option.value))
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Sorting);

/***/ }),

/***/ 95917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card; },
  "As": function() { return /* reexport */ SkeletonCard; },
  "kI": function() { return /* reexport */ VEHICLE_TYPE_NUMBER_KEY; }
});

// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/components/features/Basket/components/AddToBasket/AddToBasket.tsx + 1 modules
var AddToBasket = __webpack_require__(33830);
// EXTERNAL MODULE: ./src/components/features/ProductsList/product/Card/Card.module.css
var Card_module = __webpack_require__(67198);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/link.js
var next_link = __webpack_require__(92072);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/shared/BaseProductInfo/BaseProductInfo.tsx
var BaseProductInfo = __webpack_require__(39169);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ./src/components/features/index.ts + 21 modules
var features = __webpack_require__(34);
// EXTERNAL MODULE: ./src/components/features/Favorites/AddFavoriteButton/AddFavoriteButton.tsx
var AddFavoriteButton = __webpack_require__(83509);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 6 modules
var hooks = __webpack_require__(76345);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ./public/assets/splash-new.svg
var splash_new = __webpack_require__(2684);
var splash_new_default = /*#__PURE__*/__webpack_require__.n(splash_new);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/product/Card/Card.tsx
















const VEHICLE_TYPE_NUMBER_KEY = 'vehicle-type-number';
const SkeletonCard = () => (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
  className: (Card_module_default()).root,
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
    className: (Card_module_default()).skeletonImageContainer,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
      width: "75px",
      height: "75px"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "90%",
        height: "20px"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "60%",
        height: "15px"
      })]
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
    className: (Card_module_default()).addToBasketSection,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (Card_module_default()).price,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "140px",
        height: "35px"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (Card_module_default()).stockStatus,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "100px",
        height: "20px"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (Card_module_default()).addToBasket,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "170px",
        height: "40px"
      })
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (Card_module_default()).partCriteriasContainer,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "100%",
        height: "100px"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "120px",
        height: "20px"
      })]
    })
  })]
});
const Card = _ref => {
  var _product$data, _product$data$Remark, _product$data$Remark$, _data$PartCriterias, _data$PartCriterias$v, _data$PartCriterias2, _data$PartCriterias2$, _data$PartCriterias2$2, _data$PartCriterias2$3, _data$PartCriterias2$4, _data$PictureWebFull, _data$JpGroupNumber, _data$OldJPNumber, _data$SuitableForExpr, _data$PackingUnit, _data$Unit, _data$JpgTrafficLight, _data$HowTrafficLight, _data$ShowJpStock, _data$HowStock, _data$ExpectedDate, _data$PackingUnit2;

  let {
    product,
    selectedVehicleTypeNumber
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  if (!product) return null;
  const {
    displayName,
    data,
    productId,
    brand
  } = product || {};
  const isNewProduct = (product === null || product === void 0 ? void 0 : (_product$data = product.data) === null || _product$data === void 0 ? void 0 : (_product$data$Remark = _product$data.Remark) === null || _product$data$Remark === void 0 ? void 0 : (_product$data$Remark$ = _product$data$Remark.value) === null || _product$data$Remark$ === void 0 ? void 0 : _product$data$Remark$.toLowerCase()) === 'new';
  const generatedPDPLink = (0,utils/* generatePDPLink */.wP)({
    productId,
    variantId: productId,
    displayName: displayName || 'product'
  });
  const PDPLink = selectedVehicleTypeNumber ? `${generatedPDPLink}?${VEHICLE_TYPE_NUMBER_KEY}=${selectedVehicleTypeNumber}` : generatedPDPLink;
  const partCriterias = data !== null && data !== void 0 && (_data$PartCriterias = data.PartCriterias) !== null && _data$PartCriterias !== void 0 && (_data$PartCriterias$v = _data$PartCriterias.value) !== null && _data$PartCriterias$v !== void 0 && _data$PartCriterias$v.$values.length ? data === null || data === void 0 ? void 0 : (_data$PartCriterias2 = data.PartCriterias) === null || _data$PartCriterias2 === void 0 ? void 0 : (_data$PartCriterias2$ = _data$PartCriterias2.value) === null || _data$PartCriterias2$ === void 0 ? void 0 : (_data$PartCriterias2$2 = _data$PartCriterias2$.$values) === null || _data$PartCriterias2$2 === void 0 ? void 0 : (_data$PartCriterias2$3 = _data$PartCriterias2$2.map(_ref2 => {
    let {
      data
    } = _ref2;
    return data;
  })) === null || _data$PartCriterias2$3 === void 0 ? void 0 : (_data$PartCriterias2$4 = _data$PartCriterias2$3.sort((a, b) => {
    var _a$SortNo, _b$SortNo;

    return Number(a === null || a === void 0 ? void 0 : (_a$SortNo = a.SortNo) === null || _a$SortNo === void 0 ? void 0 : _a$SortNo.value) - Number(b === null || b === void 0 ? void 0 : (_b$SortNo = b.SortNo) === null || _b$SortNo === void 0 ? void 0 : _b$SortNo.value);
  })) === null || _data$PartCriterias2$4 === void 0 ? void 0 : _data$PartCriterias2$4.slice(0, 3) : [];
  const isJPGroup = (0,dist.isJPG)() || (0,dist.isPorsche)();
  const showPrices = !isJPGroup || isAuthenticated;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (Card_module_default()).root,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      passHref: true,
      "aria-label": displayName,
      title: displayName,
      href: PDPLink,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
        href: PDPLink,
        className: (Card_module_default()).productLink,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: (Card_module_default()).splashesContainer,
          children: isNewProduct && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Image */.Ee, {
            src: (splash_new_default()),
            objectFit: "contain"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseProductInfo/* default */.Z, {
          imgSrc: data === null || data === void 0 ? void 0 : (_data$PictureWebFull = data.PictureWebFull) === null || _data$PictureWebFull === void 0 ? void 0 : _data$PictureWebFull.value,
          productName: displayName,
          jpGroupNumber: data === null || data === void 0 ? void 0 : (_data$JpGroupNumber = data.JpGroupNumber) === null || _data$JpGroupNumber === void 0 ? void 0 : _data$JpGroupNumber.value,
          oeNumber: data === null || data === void 0 ? void 0 : (_data$OldJPNumber = data.OldJPNumber) === null || _data$OldJPNumber === void 0 ? void 0 : _data$OldJPNumber.value,
          brand: brand === null || brand === void 0 ? void 0 : brand.displayName,
          suitableForExpress: (data === null || data === void 0 ? void 0 : (_data$SuitableForExpr = data.SuitableForExpres) === null || _data$SuitableForExpr === void 0 ? void 0 : _data$SuitableForExpr.value.toLowerCase()) === 'yes' ? 'yes' : 'no',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddFavoriteButton/* default */.Z, {
            productId: productId,
            className: (Card_module_default()).addFavoriteBtn
          })
        })]
      })
    }), showPrices && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("section", {
      className: (Card_module_default()).addToBasketSection,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (Card_module_default()).price,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* CustomerPrice */.VA, {
          className: (Card_module_default()).price,
          variantId: productId,
          packingUnit: data === null || data === void 0 ? void 0 : (_data$PackingUnit = data.PackingUnit) === null || _data$PackingUnit === void 0 ? void 0 : _data$PackingUnit.value,
          unit: data === null || data === void 0 ? void 0 : (_data$Unit = data.Unit) === null || _data$Unit === void 0 ? void 0 : _data$Unit.value,
          showPriceOffers: true
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (Card_module_default()).stockStatus,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* StockStatus */.BQ, {
          productId: productId,
          statusCode: isJPGroup ? data === null || data === void 0 ? void 0 : (_data$JpgTrafficLight = data.JpgTrafficLight) === null || _data$JpgTrafficLight === void 0 ? void 0 : _data$JpgTrafficLight.value : data === null || data === void 0 ? void 0 : (_data$HowTrafficLight = data.HowTrafficLight) === null || _data$HowTrafficLight === void 0 ? void 0 : _data$HowTrafficLight.value,
          amount: isJPGroup ? data === null || data === void 0 ? void 0 : (_data$ShowJpStock = data.ShowJpStock) === null || _data$ShowJpStock === void 0 ? void 0 : _data$ShowJpStock.value : data === null || data === void 0 ? void 0 : (_data$HowStock = data.HowStock) === null || _data$HowStock === void 0 ? void 0 : _data$HowStock.value,
          expectedDeliveryDate: data === null || data === void 0 ? void 0 : (_data$ExpectedDate = data.ExpectedDate) === null || _data$ExpectedDate === void 0 ? void 0 : _data$ExpectedDate.value
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (Card_module_default()).addToBasket,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddToBasket/* default */.Z, {
          small: true,
          productId: productId,
          variantId: productId,
          colli: Number((data === null || data === void 0 ? void 0 : (_data$PackingUnit2 = data.PackingUnit) === null || _data$PackingUnit2 === void 0 ? void 0 : _data$PackingUnit2.value) || 1),
          hideButtonText: true
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (Card_module_default()).partCriteriasContainer,
        children: partCriterias !== null && partCriterias !== void 0 && partCriterias.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
            className: (Card_module_default()).partCriterias,
            children: partCriterias === null || partCriterias === void 0 ? void 0 : partCriterias.map((item, i) => {
              var _item$CritNo, _item$CriteriaDesc, _item$CriteriaValueDe;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                className: (Card_module_default()).linkageItem,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "bodyExtraSmall",
                  color: "natural700Color",
                  children: item === null || item === void 0 ? void 0 : (_item$CriteriaDesc = item.CriteriaDesc) === null || _item$CriteriaDesc === void 0 ? void 0 : _item$CriteriaDesc.value
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "bodyExtraSmall",
                  children: item === null || item === void 0 ? void 0 : (_item$CriteriaValueDe = item.CriteriaValueDesc) === null || _item$CriteriaValueDe === void 0 ? void 0 : _item$CriteriaValueDe.value
                })]
              }, `${item === null || item === void 0 ? void 0 : (_item$CritNo = item.CritNo) === null || _item$CritNo === void 0 ? void 0 : _item$CritNo.value}-${i}`);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: PDPLink,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Link */.rU, {
              href: PDPLink,
              underline: true,
              children: translate('product.seeAllReferences')
            })
          })]
        }) : null
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/ProductsList/product/Card/index.tsx


/***/ }),

/***/ 34:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v0": function() { return /* reexport */ ActiveFacets/* ActiveFacets */.v; },
  "VA": function() { return /* reexport */ CustomerPrice; },
  "fr": function() { return /* reexport */ LoadMore; },
  "TR": function() { return /* reexport */ Logo; },
  "L6": function() { return /* reexport */ MetaFields; },
  "P_": function() { return /* reexport */ Notifications/* Notification */.P; },
  "NO": function() { return /* reexport */ PriceGroup; },
  "cm": function() { return /* reexport */ ProductList; },
  "BQ": function() { return /* reexport */ StockStatus; },
  "N5": function() { return /* reexport */ Basket/* errorToJson */.N5; },
  "gP": function() { return /* reexport */ relewiseFetcher; },
  "y": function() { return /* reexport */ useCustomerPrices; },
  "r": function() { return /* reexport */ useRelewiseData; }
});

// UNUSED EXPORTS: Card, FacetsFilter, Favicon, Notifications, SkeletonCard, getPercentage

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
;// CONCATENATED MODULE: ./src/components/features/Favicon/Favicon.tsx

/**
 * Adds all favicons to the head
 *
 * @NOTE: This file is automatically generated from `/helpers/generate-favicon/createFaviconComponent.ts`
 */




const Favicon = () => _jsxs(_Fragment, {
  children: [_jsx("meta", {
    name: "theme-color",
    content: "#002AC9"
  }), _jsx("meta", {
    name: "mobile-web-app-capable",
    content: "yes"
  }), _jsx("meta", {
    name: "application-name",
    content: "Hovwdiaudi"
  }), _jsx("meta", {
    name: "apple-mobile-web-app-title",
    content: "Hovwdiaudi"
  }), _jsx("meta", {
    name: "apple-mobile-web-app-status-bar-style",
    content: "black-translucent"
  }), _jsx("meta", {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }), _jsx("link", {
    rel: "shortcut icon",
    href: "/assets/favicon/favicon.ico"
  }), _jsx("link", {
    rel: "manifest",
    href: "/assets/favicon/manifest.json"
  }), _jsx("link", {
    rel: "icon",
    type: "image/png",
    sizes: "48x48",
    href: "/assets/favicon/favicon-48x48.png"
  }), _jsx("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "/assets/favicon/favicon-32x32.png"
  }), _jsx("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "/assets/favicon/favicon-16x16.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "/assets/favicon/apple-touch-icon-76x76.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "72x72",
    href: "/assets/favicon/apple-touch-icon-72x72.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "/assets/favicon/apple-touch-icon-60x60.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "57x57",
    href: "/assets/favicon/apple-touch-icon-57x57.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "/assets/favicon/apple-touch-icon-180x180.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "167x167",
    href: "/assets/favicon/apple-touch-icon-167x167.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "/assets/favicon/apple-touch-icon-152x152.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "144x144",
    href: "/assets/favicon/apple-touch-icon-144x144.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "/assets/favicon/apple-touch-icon-120x120.png"
  }), _jsx("link", {
    rel: "apple-touch-icon",
    sizes: "114x114",
    href: "/assets/favicon/apple-touch-icon-114x114.png"
  })]
});
;// CONCATENATED MODULE: ./src/components/features/Favicon/index.ts

// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/link.js
var next_link = __webpack_require__(92072);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/features/Logo/Logo.module.css
var Logo_module = __webpack_require__(10799);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/components/features/Logo/Logo.tsx






const Logo = _ref => {
  var _data$staticLinks, _data$staticLinks$fro;

  let {
    children = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* SvgIcon */.le, {
      name: "logo"
    }),
    description
  } = _ref;
  const {
    data
  } = (0,cms/* useFrame */.xQ)();
  const frontPageUrl = (data === null || data === void 0 ? void 0 : (_data$staticLinks = data.staticLinks) === null || _data$staticLinks === void 0 ? void 0 : (_data$staticLinks$fro = _data$staticLinks.frontPage) === null || _data$staticLinks$fro === void 0 ? void 0 : _data$staticLinks$fro.url) || '/';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: frontPageUrl,
    passHref: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Link */.rU, {
      href: frontPageUrl,
      "aria-label": description,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (Logo_module_default()).logo,
        children: children
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/features/Logo/index.ts

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/head.js
var head = __webpack_require__(12246);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
;// CONCATENATED MODULE: ./src/components/features/MetaFields/MetaFields.tsx





const MetaFields = () => {
  const {
    data: page
  } = (0,cms/* usePage */.qt)();
  const {
    title,
    description,
    canonical,
    hideFromRobots
  } = (page === null || page === void 0 ? void 0 : page.meta) || {};
  let metaViewport = "initial-scale=1.0, width=device-width, user-scalable=no";

  if (!utils/* isSSR */.yF && navigator.userAgent.indexOf('iPhone') > -1) {
    metaViewport = "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0";
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      charSet: "utf-8"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "viewport",
      content: metaViewport
    }), title ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: title
    }) : null, description ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "description",
      content: description
    }) : null, hideFromRobots ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "robots",
      content: "noindex"
    }) : null, canonical ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "canonical",
      href: canonical.url
    }) : null, page === null || page === void 0 ? void 0 : page.hrefLangs.map(_ref => {
      let {
        culture,
        url
      } = _ref;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
        rel: "alternate",
        hrefLang: `${culture}`,
        href: url
      }, `hreflang-${culture}`);
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/features/MetaFields/index.ts

// EXTERNAL MODULE: ./src/components/features/Notifications/index.ts + 3 modules
var Notifications = __webpack_require__(52616);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ./src/components/features/PriceGroup/PriceGroup.module.css
var PriceGroup_module = __webpack_require__(24803);
var PriceGroup_module_default = /*#__PURE__*/__webpack_require__.n(PriceGroup_module);
;// CONCATENATED MODULE: ./src/components/features/PriceGroup/PriceGroup.tsx







const PriceGroup = _ref => {
  let {
    displayPriceInclTax,
    displaySalePriceInclTax,
    displayUnitPriceInclTax,
    isOnSale,
    variant = 'body',
    orientation = 'horizontal',
    className,
    packingUnit
  } = _ref;
  const translate = (0,cms/* useTranslations */.T_)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (0,clsx_m/* default */.Z)((PriceGroup_module_default()).priceGroup, className, {
      [(PriceGroup_module_default()).priceGroupHorizontal]: orientation === 'horizontal',
      [(PriceGroup_module_default()).priceGroupVertical]: orientation === 'vertical'
    }),
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
      className: (0,clsx_m/* default */.Z)(src/* textStyles.text */.sq.text, src/* textStyles */.sq[`variant-${variant}`], src/* textStyles.as-span */.sq["as-span"], (PriceGroup_module_default()).price, {
        [(PriceGroup_module_default()).modifierOriginal]: isOnSale === true
      }),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* VisuallyHidden */.TX, {
        children: translate(`commerce.price.${isOnSale ? 'previous' : 'current'}`)
      }), packingUnit ? `${displayPriceInclTax || displayUnitPriceInclTax} / ${packingUnit}` : `${displayPriceInclTax || displayUnitPriceInclTax}`, packingUnit ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        className: (PriceGroup_module_default()).priceUnit,
        variant: "bodyExtraSmall",
        children: [translate('product.packageUnit'), " ", packingUnit]
      }) : null]
    }), isOnSale ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
      className: (0,clsx_m/* default */.Z)(src/* textStyles.text */.sq.text, src/* textStyles */.sq[`variant-${variant}`], src/* textStyles.as-span */.sq["as-span"], (PriceGroup_module_default()).price, (PriceGroup_module_default()).modifierDiscounted),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* VisuallyHidden */.TX, {
        children: translate('commerce.price.current')
      }), displaySalePriceInclTax]
    }) : null]
  });
};
;// CONCATENATED MODULE: ./src/components/features/PriceGroup/index.ts

// EXTERNAL MODULE: ./src/components/features/StockStatus/StockStatus.module.css
var StockStatus_module = __webpack_require__(60090);
var StockStatus_module_default = /*#__PURE__*/__webpack_require__.n(StockStatus_module);
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/index.ts + 10 modules
var P181Profile = __webpack_require__(67975);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 6 modules
var hooks = __webpack_require__(76345);
;// CONCATENATED MODULE: ./src/components/features/StockStatus/StockStatus.tsx







const StockStatus = _ref => {
  let {
    statusCode,
    amount,
    expectedDeliveryDate,
    productId
  } = _ref;
  const {
    isAuthenticated
  } = (0,hooks/* useAuthentication */.JL)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    isInTheList,
    watchlistMutation
  } = (0,P181Profile.useWatchlist)();
  if (typeof statusCode === undefined) return null;

  const getLabel = () => {
    var _expectedDeliveryDate;

    switch (statusCode) {
      case '0':
        return translate('stockStatus.notAvailable');

      case '1':
        return translate('stockStatus.availableAmount').replace('[amount]', amount || '');

      case '2':
        return translate('stockStatus.shippingWarehouse');

      case '3':
        return expectedDeliveryDate ? `${translate('stockStatus.expectedDelivery')}: ${expectedDeliveryDate === null || expectedDeliveryDate === void 0 ? void 0 : (_expectedDeliveryDate = expectedDeliveryDate.split(' ')) === null || _expectedDeliveryDate === void 0 ? void 0 : _expectedDeliveryDate[0]}` : translate('stockStatus.callForInfo');

      default:
        return '';
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (StockStatus_module_default()).root,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      className: (StockStatus_module_default())[`status${statusCode}`]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      className: (StockStatus_module_default())[`textColor${statusCode}`],
      as: "span",
      variant: "bodyExtraSmall",
      fontWeight: "light",
      nowrap: true,
      children: getLabel()
    }), statusCode === '0' && isAuthenticated && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Tooltip */.u, {
      content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TooltipContentWrapper */.wM, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "bodyExtraSmall",
          children: isInTheList(productId) ? translate('stockStatus.removeFromStockNotification') : translate('stockStatus.addToStockNotification')
        })
      }),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
        size: "small",
        variant: "link",
        iconName: isInTheList(productId) ? 'bell-on' : 'bell-off',
        className: (StockStatus_module_default()).watchStock,
        onClick: () => watchlistMutation.mutate(productId)
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(21175);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@relewise+client@1.14.0/node_modules/@relewise/client/dist/browser/relewise-client.js
var relewise_client = __webpack_require__(93262);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(60750);
// EXTERNAL MODULE: ./src/components/features/ProductsList/Facets/use-facets.ts
var use_facets = __webpack_require__(94567);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/router.js
var router = __webpack_require__(38019);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/hooks/use-relewise-data.ts


const _excluded = ["pageSize", "searchQuery", "shouldFetch", "includeFacets"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // const API_URL = 'https://api.relewise.com';

const API_URL = (0,dist.getRelewiseAPIUrl)();
const DATASET_ID = (0,dist.getRelewiseDataset)();
const AUTHORIZATION = (0,dist.getRelewiseKey)();
const searcher = new relewise_client.Searcher(DATASET_ID, AUTHORIZATION, {
  serverUrl: API_URL
});
;
const isJPGroup = (0,dist.isJPG)() || (0,dist.isPorsche)();
const relewiseFetcher = async props => {
  var _activeFacets$find, _activeFacets$find2, _activeFacets$find3, _activeFacets$find4, _activeFacets$find5, _activeFacets$find6, _activeFacets$find7, _activeFacets$find8, _activeFacets$find9, _activeFacets$find10, _activeFacets$find10$, _activeFacets$find11, _activeFacets$find12;

  const {
    searchQuery,
    page = 1,
    pageSize,
    productCategories,
    sortBy,
    sortOrder = 'Ascending',
    brandFilter,
    productIdFilter,
    manufacturerFilter,
    vehicleTypeFilter,
    modelSeriesFilter,
    modelVersionFilter,
    vehicleTypeNumberFilter,
    newMonthFilter,
    dataFilter,
    activeFacets,
    includeFacets,
    locale,
    disallowedProductsGroups
  } = props;
  const selectedBrandFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find = activeFacets.find(f => f.key === 'Brand')) === null || _activeFacets$find === void 0 ? void 0 : _activeFacets$find.values) || [];
  const selectedCategoryFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find2 = activeFacets.find(f => f.key === 'Category')) === null || _activeFacets$find2 === void 0 ? void 0 : _activeFacets$find2.values) || [];
  const selectedManufacturerFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find3 = activeFacets.find(f => f.key === 'Manufacturer')) === null || _activeFacets$find3 === void 0 ? void 0 : _activeFacets$find3.values) || [];
  const selectedBodyTypeFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find4 = activeFacets.find(f => f.key === 'BodyType')) === null || _activeFacets$find4 === void 0 ? void 0 : _activeFacets$find4.values) || [];
  const selectedVehicleTypeFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find5 = activeFacets.find(f => f.key === 'VehicleType')) === null || _activeFacets$find5 === void 0 ? void 0 : _activeFacets$find5.values) || [];
  const selectedModelSeriesFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find6 = activeFacets.find(f => f.key === 'ModelSeries')) === null || _activeFacets$find6 === void 0 ? void 0 : _activeFacets$find6.values) || [];
  const selectedModelVersionFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find7 = activeFacets.find(f => f.key === 'ModelVersion')) === null || _activeFacets$find7 === void 0 ? void 0 : _activeFacets$find7.values) || []; // const selectedRemarkFacet = activeFacets?.find(f => f.key === 'Remark')?.values || []

  const selectedFuelTypeFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find8 = activeFacets.find(f => f.key === 'FuelType')) === null || _activeFacets$find8 === void 0 ? void 0 : _activeFacets$find8.values) || [];
  const selectedProductionYearsFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find9 = activeFacets.find(f => f.key === 'ProductionYears')) === null || _activeFacets$find9 === void 0 ? void 0 : _activeFacets$find9.values) || [];
  const selectedIsClassicFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find10 = activeFacets.find(f => f.key === 'IsClassic')) === null || _activeFacets$find10 === void 0 ? void 0 : (_activeFacets$find10$ = _activeFacets$find10.values) === null || _activeFacets$find10$ === void 0 ? void 0 : _activeFacets$find10$.map(v => v === 'true' ? true : false)) || [];
  const selectedCategoryHierarchyFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find11 = activeFacets.find(f => f.key === 'CategoryHierarchy')) === null || _activeFacets$find11 === void 0 ? void 0 : _activeFacets$find11.values) || [];
  const selectedNewMonthFacet = (activeFacets === null || activeFacets === void 0 ? void 0 : (_activeFacets$find12 = activeFacets.find(f => f.key === 'NewMonth')) === null || _activeFacets$find12 === void 0 ? void 0 : _activeFacets$find12.values) || [];
  const settings = {
    language: locale,
    currency: "DKK",
    displayedAtLocation: "search page",
    user: relewise_client.UserFactory.anonymous()
  };
  const requestBodyBuilder = new relewise_client.ProductSearchBuilder(settings).setSelectedProductProperties({
    displayName: true,
    pricing: true,
    brand: true,
    categoryPaths: true,
    // Specify only the needed data keys to reduce the response time or use
    // allData: true,
    // allVariants: true,
    dataKeys: ['PartCriterias', 'PictureWebFull', 'OldJPNumber', 'Unit', 'PackingUnit', 'JpgStock', 'JpgTrafficLight', 'HowStock', 'HowTrafficLight', 'ShowOnJPG', 'ShowOnHOW', 'JpGroupNumber', 'ExpectedDate', 'Remark', 'SuitableForExpres', 'NewMonth' // 'Linkages' // remove
    ]
  }).setTerm(searchQuery).pagination(p => p.setPageSize(pageSize || 0).setPage(page)) // Facets
  // The array of the available facets will be in the same order they are called
  .facets(facet => {
    if (includeFacets) {
      facet.addProductDataObjectFacet("Linkages", "Product", o => {
        o.addBooleanFacet("IsClassic", selectedIsClassicFacet);
        o.addStringFacet("Manufacturer", selectedManufacturerFacet);
        o.addStringFacet("ModelSeries", selectedModelSeriesFacet);
        o.addStringFacet("ModelVersion", selectedModelVersionFacet);
        o.addStringFacet("ProductionYears", selectedProductionYearsFacet, "And");
        o.addStringFacet("BodyType", selectedBodyTypeFacet);
        o.addStringFacet("VehicleType", selectedVehicleTypeFacet);
        o.addStringFacet("FuelType", selectedFuelTypeFacet);
      });
      facet.addProductDataStringValueFacet("NewMonth", "Product", selectedNewMonthFacet);
      facet.addBrandFacet(selectedBrandFacet);
      facet.addCategoryFacet('Ancestors', selectedCategoryFacet);
      facet.addProductCategoryHierarchyFacet("ImmediateParent", (selectedCategoryHierarchyFacet === null || selectedCategoryHierarchyFacet === void 0 ? void 0 : selectedCategoryHierarchyFacet.map(hierarchyFacet => {
        const ids = hierarchyFacet.split("-");
        return {
          breadcrumbPathStartingFromRoot: [{
            id: ids[0]
          }, {
            id: ids[1]
          }]
        };
      })) || null, {
        displayName: true
      });
    }

    return facet;
  }) // sorting
  .sorting(sort => {
    if (sortBy) {
      sort.sortByProductData(sortBy, 'Product', sortOrder);
    } else {
      sort.sortByProductRelevance();
    }

    return sort;
  }) // Filters
  .filters(filter => {
    filter.addProductDataFilter(isJPGroup ? 'ShowOnJPG' : 'ShowOnHOW', conditions => conditions.addEqualsCondition(relewise_client.DataValueFactory.boolean(true)));

    if (productCategories !== null && productCategories !== void 0 && productCategories.length) {
      filter.addProductCategoryIdFilter('ImmediateParent', productCategories);
    }

    if (brandFilter !== null && brandFilter !== void 0 && brandFilter.length) {
      filter.addBrandIdFilter(brandFilter);
    }

    if (productIdFilter !== null && productIdFilter !== void 0 && productIdFilter.length) {
      filter.addProductIdFilter(productIdFilter);
    }

    if (disallowedProductsGroups !== null && disallowedProductsGroups !== void 0 && disallowedProductsGroups.length) {
      filter.addProductDataFilter("StatGroupId", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(disallowedProductsGroups), undefined, true));
    } // Added filters for optimization with flattened keys


    if (selectedBodyTypeFacet !== null && selectedBodyTypeFacet !== void 0 && selectedBodyTypeFacet.length) {
      filter.addProductDataFilter("BodyType", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedBodyTypeFacet), 'Any'));
    }

    if (selectedModelSeriesFacet !== null && selectedModelSeriesFacet !== void 0 && selectedModelSeriesFacet.length) {
      filter.addProductDataFilter("ModelSeries", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedModelSeriesFacet), 'Any'));
    }

    if (selectedProductionYearsFacet !== null && selectedProductionYearsFacet !== void 0 && selectedProductionYearsFacet.length) {
      filter.addProductDataFilter("ProductionYears", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedProductionYearsFacet), 'Any'));
    }

    if (selectedIsClassicFacet !== null && selectedIsClassicFacet !== void 0 && selectedIsClassicFacet.length) {
      filter.addProductDataFilter("IsClassic", c => c.addContainsCondition(relewise_client.DataValueFactory.booleanCollection(selectedIsClassicFacet), 'Any'));
    }

    if (selectedManufacturerFacet !== null && selectedManufacturerFacet !== void 0 && selectedManufacturerFacet.length) {
      filter.addProductDataFilter("Manufacturer", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedManufacturerFacet), 'Any'));
    }

    if (selectedModelVersionFacet !== null && selectedModelVersionFacet !== void 0 && selectedModelVersionFacet.length) {
      filter.addProductDataFilter("ModelVersion", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedModelVersionFacet), 'Any'));
    }

    if (selectedVehicleTypeFacet !== null && selectedVehicleTypeFacet !== void 0 && selectedVehicleTypeFacet.length) {
      filter.addProductDataFilter("VehicleType", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedVehicleTypeFacet), 'Any'));
    }

    if (selectedFuelTypeFacet !== null && selectedFuelTypeFacet !== void 0 && selectedFuelTypeFacet.length) {
      filter.addProductDataFilter("FuelType", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedFuelTypeFacet), 'Any'));
    }

    if (selectedNewMonthFacet !== null && selectedNewMonthFacet !== void 0 && selectedNewMonthFacet.length) {
      filter.addProductDataFilter("NewMonth", c => c.addContainsCondition(relewise_client.DataValueFactory.stringCollection(selectedNewMonthFacet), 'Any'));
    }

    if (dataFilter !== null && dataFilter !== void 0 && dataFilter.length) {
      dataFilter.forEach(el => {
        var _el$values;

        if ((_el$values = el.values) !== null && _el$values !== void 0 && _el$values.length) {
          filter.or(or => {
            var _el$values2;

            (_el$values2 = el.values) === null || _el$values2 === void 0 ? void 0 : _el$values2.forEach(v => {
              or.addProductDataFilter(el.key, cond => cond.addEqualsCondition(relewise_client.DataValueFactory.string(v)));
            });
          });
        }
      });
    } // Vehicle filters


    if (manufacturerFilter !== null && manufacturerFilter !== void 0 && manufacturerFilter.length || vehicleTypeFilter !== null && vehicleTypeFilter !== void 0 && vehicleTypeFilter.length || modelSeriesFilter !== null && modelSeriesFilter !== void 0 && modelSeriesFilter.length || modelVersionFilter !== null && modelVersionFilter !== void 0 && modelVersionFilter.length || vehicleTypeNumberFilter !== null && vehicleTypeNumberFilter !== void 0 && vehicleTypeNumberFilter.length || newMonthFilter !== null && newMonthFilter !== void 0 && newMonthFilter.length) filter.addProductDataFilter('Linkages', f => {
      f.addDataObjectCondition(cond => {
        if (manufacturerFilter !== null && manufacturerFilter !== void 0 && manufacturerFilter.length) {
          cond.addEqualsCondition('Manufacturer', relewise_client.DataValueFactory.stringCollection(manufacturerFilter));
        }

        if (vehicleTypeFilter !== null && vehicleTypeFilter !== void 0 && vehicleTypeFilter.length) {
          cond.addEqualsCondition('VehicleType', relewise_client.DataValueFactory.stringCollection(vehicleTypeFilter));
        }

        if (modelSeriesFilter !== null && modelSeriesFilter !== void 0 && modelSeriesFilter.length) {
          cond.addEqualsCondition('ModelSeries', relewise_client.DataValueFactory.stringCollection(modelSeriesFilter));
        }

        if (modelVersionFilter !== null && modelVersionFilter !== void 0 && modelVersionFilter.length) {
          cond.addEqualsCondition('ModelVersion', relewise_client.DataValueFactory.stringCollection(modelVersionFilter));
        }

        if (vehicleTypeNumberFilter !== null && vehicleTypeNumberFilter !== void 0 && vehicleTypeNumberFilter.length) {
          cond.addEqualsCondition('VehicleTypeNumber', relewise_client.DataValueFactory.doubleCollection(vehicleTypeNumberFilter));
        }

        if (newMonthFilter !== null && newMonthFilter !== void 0 && newMonthFilter.length) {
          cond.addEqualsCondition('NewMonth', relewise_client.DataValueFactory.stringCollection(newMonthFilter));
        } // FOR documentation purposes !!!!
        // cond.addEqualsCondition('VehicleTypeNumber', DataValueFactory.number(6203))
        // cond.addEqualsCondition('Manufacturer', DataValueFactory.string('VOLVO'))
        // cond.addContainsCondition('ProductionYears', DataValueFactory.stringCollection(['1959', '1972', '2020']), 'Any')
        // cond.addInRangeCondition('Bhp', { lowerBoundInclusive: 50, upperBoundInclusive: 80 })

      });
    });
    return filter;
  });
  const request = await searcher.searchProducts(requestBodyBuilder.build());
  return request;
};
const useRelewiseData = props => {
  var _data$pages, _data$pages$, _data$pages$2;

  const {
    pageSize = 30,
    searchQuery,
    shouldFetch = true,
    includeFacets = true
  } = props,
        rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  const {
    locale,
    defaultLocale
  } = (0,router.useRouter)();
  const {
    data: userInformation
  } = (0,P181Profile.useUserInformation)();
  const disallowedProductsGroups = (userInformation === null || userInformation === void 0 ? void 0 : userInformation.disallowedProductsGroups) || [];
  const {
    activeFacets
  } = (0,use_facets/* default */.ZP)();
  const queryKey = ['relewise productList', searchQuery, [...activeFacets], _objectSpread({}, rest)];
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetching
  } = (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    queryKey,
    queryFn: _ref => {
      let {
        pageParam = 1
      } = _ref;
      return relewiseFetcher(_objectSpread({
        activeFacets,
        disallowedProductsGroups,
        pageSize,
        page: pageParam,
        locale: locale || defaultLocale || '',
        includeFacets,
        searchQuery
      }, rest));
    },
    keepPreviousData: true,
    getNextPageParam: (lastPage, pages) => {
      const hits = (lastPage === null || lastPage === void 0 ? void 0 : lastPage.hits) || 0;
      const totalPages = Math.ceil(hits / pageSize);
      const loadedPagesLength = (pages === null || pages === void 0 ? void 0 : pages.length) || 1;

      if ((pages === null || pages === void 0 ? void 0 : pages.length) >= totalPages) {
        return undefined;
      }

      return loadedPagesLength + 1;
    },
    enabled: shouldFetch,
    staleTime: 1000 * 60 * 60,
    // 1 hour
    cacheTime: 1000 * 60 * 60 // 1 hour

  });
  const products = (data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.map(p => p === null || p === void 0 ? void 0 : p.results).flat()) || [];
  return {
    totalProducts: (data === null || data === void 0 ? void 0 : (_data$pages$ = data.pages[0]) === null || _data$pages$ === void 0 ? void 0 : _data$pages$.hits) || 0,
    products,
    facets: (data === null || data === void 0 ? void 0 : (_data$pages$2 = data.pages[0]) === null || _data$pages$2 === void 0 ? void 0 : _data$pages$2.facets) || null,
    isError: error,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage
  };
};
;// CONCATENATED MODULE: ./src/components/features/ProductsList/hooks/index.ts

// EXTERNAL MODULE: ./src/components/features/ProductsList/product/Card/index.tsx + 1 modules
var Card = __webpack_require__(95917);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/product/index.ts

// EXTERNAL MODULE: ./src/components/features/ProductsList/ProductList.module.css
var ProductList_module = __webpack_require__(74342);
var ProductList_module_default = /*#__PURE__*/__webpack_require__.n(ProductList_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/xlsx@0.18.5/node_modules/xlsx/xlsx.mjs
var xlsx = __webpack_require__(63705);
// EXTERNAL MODULE: ./src/shared/hooks/useNotification/index.ts + 2 modules
var useNotification = __webpack_require__(78560);
;// CONCATENATED MODULE: ./src/components/features/DownloadProductList/DownloadProductList.tsx







 // import { generatePDPLink } from '~/shared/utils';
// import { isJPG } from 'utils';
// const isJPGroup = isJPG()
// import styles from './Component.module.scss'



const DownloadProductList = props => {
  const {
    searchQuery,
    vehicleTypeNumberFilter,
    totalProductsCount = 10000
  } = props;
  const {
    0: isFetching,
    1: setIsFetching
  } = (0,react.useState)(false);
  const {
    push
  } = (0,useNotification/* useNotification */.l)();
  const {
    locale,
    defaultLocale
  } = (0,router.useRouter)();
  const {
    data: userInformation
  } = (0,P181Profile.useUserInformation)();
  const {
    activeFacets
  } = (0,use_facets/* default */.ZP)();
  const disallowedProductsGroups = (userInformation === null || userInformation === void 0 ? void 0 : userInformation.disallowedProductsGroups) || [];

  const mapData = data => {
    return data === null || data === void 0 ? void 0 : data.map(product => {
      var _data$JpGroupNumber;

      const {
        displayName,
        data
      } = product; // const PDPLink = generatePDPLink({
      //     productId,
      //     variantId: productId,
      //     displayName: displayName || 'product'
      // })

      return {
        JPGroupNumber: data === null || data === void 0 ? void 0 : (_data$JpGroupNumber = data.JpGroupNumber) === null || _data$JpGroupNumber === void 0 ? void 0 : _data$JpGroupNumber.value,
        DisplayName: displayName // Remark: data?.Remark?.value,
        // NewMonth: data?.NewMonth?.value,
        // Brand: brand.displayName,
        // PackingUnit: data?.PackingUnit?.value,
        // Availability: isJPGroup ? data?.ShowJpStock?.value : data?.HowStock?.value,
        // Image: data?.PictureWebFull?.value,
        // ProductLink: PDPLink,

      };
    });
  };

  const downloadFile = async () => {
    setIsFetching(true);

    try {
      const data = await relewiseFetcher({
        locale: locale || defaultLocale || 'en',
        searchQuery,
        activeFacets,
        pageSize: totalProductsCount,
        vehicleTypeNumberFilter,
        disallowedProductsGroups
      });
      downloadExcel(mapData(data === null || data === void 0 ? void 0 : data.results));
    } catch (error) {
      push({
        severity: 'warning',
        text: 'Something went wrong'
      });
    } finally {
      setIsFetching(false);
    }
  };

  const downloadExcel = data => {
    const worksheet = xlsx/* utils.json_to_sheet */.P6.json_to_sheet(data);
    const workbook = xlsx/* utils.book_new */.P6.book_new();
    xlsx/* utils.book_append_sheet */.P6.book_append_sheet(workbook, worksheet, "Sheet1"); //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

    xlsx/* writeFile */.NC(workbook, "DataSheet.xls");
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      onClick: () => downloadFile(),
      isLoading: isFetching,
      iconName: "download",
      size: "small",
      variant: "secondary"
    })
  });
};

/* harmony default export */ var DownloadProductList_DownloadProductList = (DownloadProductList);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/ProductList.tsx


const ProductList_excluded = ["products", "totalProducts", "isLoading", "isFetching", "headline", "selectedVehicleTypeNumber"];

function ProductList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProductList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProductList_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProductList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const SkeletonList = () => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: Array.from(Array(5).keys()).map(item => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* SkeletonCard */.As, {}, item))
});

const ProductList = _ref => {
  let {
    products,
    totalProducts,
    isLoading,
    isFetching,
    headline,
    selectedVehicleTypeNumber
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProductList_excluded);

  const translate = (0,cms/* useTranslations */.T_)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (ProductList_module_default()).root,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (ProductList_module_default()).header,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (ProductList_module_default()).headerLeft,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "body",
          className: (ProductList_module_default()).plpTitle,
          children: headline ? headline : translate('product.products')
        }), isFetching && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Loader */.aN, {
          size: "15px",
          borderWidth: "2px",
          padding: "0"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: (ProductList_module_default()).headerRight,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "bodySmall",
          children: [totalProducts, " ", translate('product.results')]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadProductList_DownloadProductList, ProductList_objectSpread({
          totalProductsCount: totalProducts
        }, rest))]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (ProductList_module_default()).productList,
      children: isLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonList, {}) : products === null || products === void 0 ? void 0 : products.map((product, index) => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Card */.Zb, {
        selectedVehicleTypeNumber: selectedVehicleTypeNumber,
        product: product
      }, `${index}-${product === null || product === void 0 ? void 0 : product.productId}`))
    })]
  });
};
// EXTERNAL MODULE: ./src/components/features/ProductsList/Facets/FacetsFilter/FacetsFilter.tsx
var FacetsFilter = __webpack_require__(28198);
// EXTERNAL MODULE: ./src/components/features/ProductsList/Facets/ActiveFacets/ActiveFacets.tsx
var ActiveFacets = __webpack_require__(71243);
// EXTERNAL MODULE: ./src/components/features/ProductsList/LoadMore/LoadMore.module.css
var LoadMore_module = __webpack_require__(44796);
var LoadMore_module_default = /*#__PURE__*/__webpack_require__.n(LoadMore_module);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/LoadMore/LoadMore.tsx






const getPercentage = (partialValue, totalValue) => {
  if (partialValue === 0 || totalValue === 0) return 0;
  return 100 * partialValue / totalValue;
};
const LoadMore = props => {
  const {
    total = 0,
    loaded = 0,
    onClick,
    isFetching,
    hasNextPage
  } = props;
  const translate = (0,cms/* useTranslations */.T_)();
  const buttonEl = (0,react.useRef)(null);
  const allLoaded = total <= loaded;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (LoadMore_module_default()).root,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (LoadMore_module_default()).progress,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Progress */.Ex, {
        percentage: getPercentage(loaded, total)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      children: translate('common.showLoadedOutOfTotal').replace('[loaded]', loaded.toString()).replace('[total]', total.toString())
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
      isLoading: isFetching,
      onClick: onClick,
      ref: buttonEl,
      disabled: !hasNextPage || isFetching || allLoaded,
      children: translate('common.loadMore')
    })]
  });
};
// EXTERNAL MODULE: ./src/components/features/ProductsList/Sorting/Sorting.tsx
var Sorting = __webpack_require__(33692);
// EXTERNAL MODULE: ./src/components/features/ProductsList/MobileFilters/MobileFilters.tsx
var MobileFilters = __webpack_require__(67160);
;// CONCATENATED MODULE: ./src/components/features/ProductsList/index.ts








// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(72603);
;// CONCATENATED MODULE: ./src/components/features/CustomerPrice/hooks/use-customer-prices.ts


function use_customer_prices_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function use_customer_prices_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? use_customer_prices_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : use_customer_prices_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



const useCustomerPrices = function (variantIds) {
  let shouldFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const {
    catalogueBaseUrl
  } = (0,hooks/* usePrefixUrl */.Yp)();
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const url = `${catalogueBaseUrl}/prices`;
  const headers = new Headers({
    'Content-Type': 'application/json'
  });

  if (session !== null && session !== void 0 && session.accessToken) {
    headers.append('Authorization', `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`);
  }

  return (0,useQuery/* useQuery */.a)({
    queryKey: ['productPrices', variantIds.join('-'), session === null || session === void 0 ? void 0 : session.accessToken],
    enabled: shouldFetch && !!(variantIds !== null && variantIds !== void 0 && variantIds.length),
    queryFn: async () => {
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(variantIds),
        headers
      });
      const json = await res.json();
      return use_customer_prices_objectSpread(use_customer_prices_objectSpread({}, json), {}, {
        statusCode: res.status
      });
    }
  });
};
;// CONCATENATED MODULE: ./src/components/features/CustomerPrice/hooks/index.ts

// EXTERNAL MODULE: ./src/components/features/CustomerPrice/CustomerPrice.module.css
var CustomerPrice_module = __webpack_require__(58428);
var CustomerPrice_module_default = /*#__PURE__*/__webpack_require__.n(CustomerPrice_module);
// EXTERNAL MODULE: ./src/components/shared/ErrorBox/ErrorBox.tsx
var ErrorBox = __webpack_require__(50764);
// EXTERNAL MODULE: ./src/components/features/PriceOffers/PriceOffers.tsx
var PriceOffers = __webpack_require__(18603);
;// CONCATENATED MODULE: ./src/components/features/CustomerPrice/CustomerPrice.tsx






 // import { useOnScreen } from 'utils';






const CustomerPrice_isJPGroup = (0,dist.isJPG)() || dist.isPorsche;
const CustomerPrice = props => {
  const {
    packingUnit,
    salesPrice,
    uniPrice,
    unit,
    variantId,
    className,
    alignItems = 'right',
    isLarge,
    showPriceOffers
  } = props;
  const ref = (0,react.useRef)(null); // const isVisible = useOnScreen(ref, { rootMargin: '1000px' });

  const shouldFetch = !salesPrice; // && isVisible

  const {
    data,
    isLoading,
    isError
  } = useCustomerPrices(variantId ? [variantId] : [], shouldFetch);
  const translate = (0,cms/* useTranslations */.T_)();
  const asyncPrice = (data === null || data === void 0 ? void 0 : data[0]) || undefined;
  const displayPrice = salesPrice || (asyncPrice === null || asyncPrice === void 0 ? void 0 : asyncPrice.taxedPrice);
  const displayUnitPrice = uniPrice || (asyncPrice === null || asyncPrice === void 0 ? void 0 : asyncPrice.unitPrice);
  const classNames = (0,clsx_m/* default */.Z)((CustomerPrice_module_default()).root, className, (CustomerPrice_module_default())[`${alignItems}Align`]);

  function renderContent() {
    if (shouldFetch && isLoading) return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "120px",
        height: isLarge ? '25px' : '22px',
        className: isLarge ? (CustomerPrice_module_default()).skeletonPriceLarge : (CustomerPrice_module_default()).skeletonPrice
      }), CustomerPrice_isJPGroup && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Skeleton */.Od, {
        width: "100px",
        height: "13px"
      })]
    });
    if (isError) return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBox/* default */.Z, {});
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        as: "div",
        fontWeight: "semiBold",
        variant: isLarge ? "display5" : "display6",
        children: [displayPrice, " ", unit && `/ ${unit}`]
      }), showPriceOffers && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceOffers/* default */.Z, {
        values: asyncPrice === null || asyncPrice === void 0 ? void 0 : asyncPrice.priceOffers
      }), CustomerPrice_isJPGroup && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          as: "div",
          variant: "bodyExtraSmall",
          children: [translate('product.packageUnit'), " ", packingUnit]
        })
      }), !CustomerPrice_isJPGroup && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          as: "div",
          fontWeight: "regular",
          color: "natural700Color",
          variant: isLarge ? "bodySmall" : "bodyExtraSmall",
          children: [displayUnitPrice, " ", unit && `/ ${unit}`]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "div",
          fontWeight: "regular",
          color: "natural700Color",
          variant: isLarge ? "bodySmall" : "bodyExtraSmall",
          children: translate('product.withoutVat')
        })]
      })]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: classNames,
    ref: ref,
    children: renderContent()
  });
};
;// CONCATENATED MODULE: ./src/components/features/CustomerPrice/index.ts


// EXTERNAL MODULE: ./src/components/features/DownloadCustomerPrices/DownloadCustomerPrices.tsx
var DownloadCustomerPrices = __webpack_require__(9223);
;// CONCATENATED MODULE: ./src/components/features/DownloadCustomerPrices/index.ts

// EXTERNAL MODULE: ./src/components/features/Basket/index.ts + 9 modules
var Basket = __webpack_require__(55057);
;// CONCATENATED MODULE: ./src/components/features/index.ts













/***/ }),

/***/ 32050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SidebarFilter; }
/* harmony export */ });
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41377);
/* harmony import */ var _SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95243);
/* harmony import */ var _SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94965);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var _components_features_ProductsList_Facets_use_facets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94567);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55060);










const SkeletonListItem = () => {
  const width = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => (0,ui__WEBPACK_IMPORTED_MODULE_0__/* .getSkeletonRandom */ .VI)(60), []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("li", {
    className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().skeletonListItem),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Skeleton */ .Od, {
      width: `${width}%`,
      height: "15px"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Skeleton */ .Od, {
      width: "25px",
      height: "15px"
    })]
  });
};

const SkeletonList = () => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
  children: Array.from(Array(20).keys()).map(item => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SkeletonListItem, {}, item))
});

const SidebarFilter = _ref => {
  var _facets$nodes;

  let {
    facets,
    isFetching,
    isLoading,
    searchQuery = ''
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
  const {
    setCategoryHierarchyFacet
  } = (0,_components_features_ProductsList_Facets_use_facets__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
      className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().header),
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
        variant: "body",
        children: translate('product.productCategories')
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Accordion */ .UQ, {
      type: "single",
      children: isLoading ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SkeletonList, {}) : facets === null || facets === void 0 ? void 0 : (_facets$nodes = facets.nodes) === null || _facets$nodes === void 0 ? void 0 : _facets$nodes.sort((a, b) => {
        var _a$category, _b$category, _a$category2, _b$category2, _a$category3, _b$category3;

        if (!(a !== null && a !== void 0 && (_a$category = a.category) !== null && _a$category !== void 0 && _a$category.displayName) || !(b !== null && b !== void 0 && (_b$category = b.category) !== null && _b$category !== void 0 && _b$category.displayName)) return 0;

        if ((a === null || a === void 0 ? void 0 : (_a$category2 = a.category) === null || _a$category2 === void 0 ? void 0 : _a$category2.displayName) < (b === null || b === void 0 ? void 0 : (_b$category2 = b.category) === null || _b$category2 === void 0 ? void 0 : _b$category2.displayName)) {
          return -1;
        }

        if ((a === null || a === void 0 ? void 0 : (_a$category3 = a.category) === null || _a$category3 === void 0 ? void 0 : _a$category3.displayName) > (b === null || b === void 0 ? void 0 : (_b$category3 = b.category) === null || _b$category3 === void 0 ? void 0 : _b$category3.displayName)) {
          return 1;
        }

        return 0;
      }).map((f, index) => {
        var _f$children, _f$category, _f$children2;

        const selectedChilds = ((_f$children = f.children) === null || _f$children === void 0 ? void 0 : _f$children.filter(option => option.selected)) || [];
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .AccordionItem */ .Qd, {
          className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().listItem),
          header: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
            className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().sidebarCategoryHeader),
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
              text: f.category.displayName || '',
              title: f.category.displayName || '',
              highlightText: searchQuery,
              overflowEllipsis: true,
              fontWeight: f.selected ? 'bold' : 'regular',
              variant: "body"
            }), selectedChilds.length > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
              color: "grey",
              children: ["(", selectedChilds.length, " ", translate('facets.quantitySelected'), ")"]
            }) : null]
          }),
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
            className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().subList),
            children: (_f$children2 = f.children) === null || _f$children2 === void 0 ? void 0 : _f$children2.sort((a, b) => {
              var _a$category4, _b$category4, _a$category5, _b$category5, _a$category6, _b$category6;

              if (!(a !== null && a !== void 0 && (_a$category4 = a.category) !== null && _a$category4 !== void 0 && _a$category4.displayName) || !(b !== null && b !== void 0 && (_b$category4 = b.category) !== null && _b$category4 !== void 0 && _b$category4.displayName)) return 0;

              if ((a === null || a === void 0 ? void 0 : (_a$category5 = a.category) === null || _a$category5 === void 0 ? void 0 : _a$category5.displayName) < (b === null || b === void 0 ? void 0 : (_b$category5 = b.category) === null || _b$category5 === void 0 ? void 0 : _b$category5.displayName)) {
                return -1;
              }

              if ((a === null || a === void 0 ? void 0 : (_a$category6 = a.category) === null || _a$category6 === void 0 ? void 0 : _a$category6.displayName) > (b === null || b === void 0 ? void 0 : (_b$category6 = b.category) === null || _b$category6 === void 0 ? void 0 : _b$category6.displayName)) {
                return 1;
              }

              return 0;
            }).map((option, index) => (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
              className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().subListItem),
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("button", {
                disabled: isFetching,
                className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().button),
                onClick: () => setCategoryHierarchyFacet(f.category.categoryId, option.category.categoryId),
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Checkbox */ .XZ, {
                  checked: option.selected
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                  className: (_SidebarFilter_module_css__WEBPACK_IMPORTED_MODULE_5___default().subCategoryText),
                  text: option.category.displayName || '',
                  title: option.category.displayName || '',
                  highlightText: searchQuery,
                  overflowEllipsis: true,
                  fontWeight: option.selected ? 'bold' : 'regular',
                  color: "natural700Color",
                  variant: "bodySmall"
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                  color: "natural700Color",
                  fontWeight: option.selected ? 'bold' : 'regular',
                  variant: "bodySmall",
                  children: ["(", option === null || option === void 0 ? void 0 : option.hits, ")"]
                })]
              }, index)
            }, `${index}-${option.category.categoryId}`))
          })
        }, `${index}-${f === null || f === void 0 ? void 0 : (_f$category = f.category) === null || _f$category === void 0 ? void 0 : _f$category.categoryId}`);
      })
    })]
  });
};

/***/ }),

/***/ 39169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1496);
/* harmony import */ var _BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var $assets_fallback_product_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23230);
/* harmony import */ var $assets_fallback_product_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n($assets_fallback_product_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41377);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55060);








const BaseProductInfo = props => {
  const {
    productName,
    imgSrc,
    jpGroupNumber,
    oeNumber,
    brand,
    suitableForExpress,
    children
  } = props;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_3__/* .useTranslations */ .T_)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
    className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().root),
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
      src: imgSrc || ($assets_fallback_product_svg__WEBPACK_IMPORTED_MODULE_1___default()),
      alt: productName,
      width: 75,
      height: 75,
      objectFit: "cover"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
      className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().description),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
        variant: "display6",
        as: "h2",
        className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().productName),
        children: productName
      }), jpGroupNumber && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().flexInfo),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          children: [translate('product.jpGroupNr'), ":"]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          color: "natural700Color",
          children: jpGroupNumber
        })]
      }), oeNumber && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().flexInfo),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          children: [translate('product.oeNumber'), ":"]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          color: "natural700Color",
          children: oeNumber
        })]
      }), brand && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().flexInfo),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          children: [translate('product.brand'), ":"]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
          nowrap: true,
          variant: "bodyExtraSmall",
          color: "natural700Color",
          children: brand
        })]
      }), suitableForExpress && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
        variant: "bodyExtraSmall",
        className: (_BaseProductInfo_module_css__WEBPACK_IMPORTED_MODULE_5___default().expressInfo),
        fontWeight: "semiBold",
        children: suitableForExpress === 'yes' ? translate('product.expressShipping') : translate('product.expressShippingFalse')
      }), children]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BaseProductInfo);

/***/ }),

/***/ 50764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _ErrorBox_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42014);
/* harmony import */ var _ErrorBox_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ErrorBox_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_cms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94965);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55060);





const ErrorBox = _ref => {
  let {
    text
  } = _ref;
  const translate = (0,_services_cms__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    className: (_ErrorBox_module_css__WEBPACK_IMPORTED_MODULE_3___default().root),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
      className: (_ErrorBox_module_css__WEBPACK_IMPORTED_MODULE_3___default().errorBox),
      children: text || translate('common.upsSomethingWentWrong')
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorBox);

/***/ }),

/***/ 93724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _PageHeaderContainer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12389);
/* harmony import */ var _PageHeaderContainer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PageHeaderContainer_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41377);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55060);





const PageHeaderContainer = _ref => {
  let {
    children,
    hidePadding
  } = _ref;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    className: hidePadding ? (_PageHeaderContainer_module_css__WEBPACK_IMPORTED_MODULE_3___default().root) : (_PageHeaderContainer_module_css__WEBPACK_IMPORTED_MODULE_3___default().rootWithPadding),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ui__WEBPACK_IMPORTED_MODULE_1__/* .ModuleContainer */ .EM, {
      hasGutter: true,
      hasPadding: false,
      children: children
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageHeaderContainer);

/***/ }),

/***/ 67975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ P181ProfilePage; },
  "useOrderHistory": function() { return /* reexport */ useOrderHistory; },
  "useUserInformation": function() { return /* reexport */ useUserInformation; },
  "useWatchlist": function() { return /* reexport */ useWatchlist; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/index.tsx + 258 modules
var src = __webpack_require__(41377);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ./src/components/features/index.ts + 21 modules
var features = __webpack_require__(34);
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/components/OrderHistoryList/OrderHistoryList.module.css
var OrderHistoryList_module = __webpack_require__(44334);
var OrderHistoryList_module_default = /*#__PURE__*/__webpack_require__.n(OrderHistoryList_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_d3zi5agmim5yvele7myolzagti/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(55060);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/components/OrderHistoryList/OrderHistoryList.tsx







const OrderHistoryList = order => {
  var _order$lines;

  const translate = (0,cms/* useTranslations */.T_)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (OrderHistoryList_module_default()).gridRoot,
    children: (_order$lines = order.lines) === null || _order$lines === void 0 ? void 0 : _order$lines.map((line, index) => (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (OrderHistoryList_module_default()).divItem,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partNo, (OrderHistoryList_module_default()).item]),
          children: translate('profile.productId')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partData, (OrderHistoryList_module_default()).item]),
          children: line.jpGroupNumber
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partNo, (OrderHistoryList_module_default()).item]),
          children: translate('profile.name')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partData, (OrderHistoryList_module_default()).item]),
          children: line.name || '-'
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).description, (OrderHistoryList_module_default()).item]),
          children: translate('profile.description')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partDesc, (OrderHistoryList_module_default()).item]),
          children: line.description || '-'
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).quantity, (OrderHistoryList_module_default()).item]),
          children: translate('profile.quantity')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          className: (0,clsx_m/* default */.Z)([(OrderHistoryList_module_default()).partQty, (OrderHistoryList_module_default()).item]),
          children: line.quantity
        })]
      })]
    }, index))
  });
};
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/components/OrderHistory/OrderHistory.module.css
var OrderHistory_module = __webpack_require__(69050);
var OrderHistory_module_default = /*#__PURE__*/__webpack_require__.n(OrderHistory_module);
// EXTERNAL MODULE: ./src/shared/utils/index.ts + 17 modules
var utils = __webpack_require__(64160);
// EXTERNAL MODULE: ../../packages/utils/dist/index.mjs
var dist = __webpack_require__(61758);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 6 modules
var hooks = __webpack_require__(76345);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/hooks/useUserInformation.ts
/* provided dependency */ var process = __webpack_require__(73656);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const useUserInformation = () => {
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const prefixUrl = new URL(dist.isBrowser ? '/api/account/proxy' : '/api', dist.isBrowser ? window.location.origin : process.env.COMMERCE_API_URL);
  const getUserInformationUrl = `${prefixUrl}/${session === null || session === void 0 ? void 0 : session.storeKey}/Account/get`;
  return _objectSpread({}, (0,utils/* useGetRequest */.aN)(getUserInformationUrl, {
    enabled: Boolean(session === null || session === void 0 ? void 0 : session.accessToken),
    retry: 2,
    keepPreviousData: true,
    headers: {
      'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
    }
  }));
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(31781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(72603);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(53083);
// EXTERNAL MODULE: ./src/shared/hooks/useNotification/index.ts + 2 modules
var useNotification = __webpack_require__(78560);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/hooks/useWatchlist.ts


function useWatchlist_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useWatchlist_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useWatchlist_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useWatchlist_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const useWatchlist = () => {
  const {
    stockNotificationBaseUrl
  } = (0,hooks/* usePrefixUrl */.Yp)();
  const {
    push
  } = (0,useNotification/* useNotification */.l)();
  const {
    isAuthenticated,
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  const {
    isLoading,
    isError,
    data
  } = (0,useQuery/* useQuery */.a)({
    refetchOnWindowFocus: true,
    queryKey: ['watchlist'],
    enabled: isAuthenticated,
    queryFn: async () => {
      const res = await fetch(stockNotificationBaseUrl, {
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });

      if (res.status === 204) {
        return {
          json: {},
          statusCode: 200
        };
      }

      const json = await res.json();
      return useWatchlist_objectSpread(useWatchlist_objectSpread({}, json), {}, {
        statusCode: res.status == 204 ? 200 : res.status
      });
    }
  });

  function isInTheList(itemId) {
    var _data$items;

    return Boolean(data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.find(f => f.productId === itemId));
  }

  const watchlistMutation = (0,useMutation/* useMutation */.D)({
    mutationFn: async id => {
      const isSelected = isInTheList(id);
      const res = await fetch(`${stockNotificationBaseUrl}/${id}`, {
        method: isSelected ? 'DELETE' : 'POST',
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
      return await res.json();
    },
    onError: async error => {
      const {
        level,
        errorMessages
      } = await (0,features/* errorToJson */.N5)(error);
      push({
        severity: level,
        text: errorMessages
      });
    },
    onSuccess: data => {
      queryClient.setQueryData(['watchlist'], data);
    }
  });
  return {
    watchlistMutation,
    data,
    isLoading,
    isError,
    isInTheList
  };
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(60750);
// EXTERNAL MODULE: ./src/components/features/Basket/index.ts + 9 modules
var Basket = __webpack_require__(55057);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/hooks/useOrderHistory.ts



const useOrderHistory = _ref => {
  var _data$pages, _data$pages$;

  let {
    skip,
    take
  } = _ref;
  const {
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const {
    orderUrl
  } = (0,Basket/* useBasketPaths */._x)();
  const getUserInformationUrl = `${orderUrl}/historypaginated/`;
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetching
  } = (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    queryKey: ["user order history paginated"],
    queryFn: async _ref2 => {
      let {
        pageParam = skip
      } = _ref2;
      const res = await fetch(getUserInformationUrl + pageParam + "/" + take, {
        headers: {
          'Authorization': `Bearer ${session === null || session === void 0 ? void 0 : session.accessToken}`
        }
      });
      return await res.json();
    },
    enabled: Boolean(session === null || session === void 0 ? void 0 : session.accessToken),
    keepPreviousData: true,
    getNextPageParam: lastPage => {
      const totalItems = lastPage.totalItems;
      const loadedItems = lastPage.skipItemsCount + lastPage.items.length;
      const noMorePages = loadedItems >= totalItems;

      if (noMorePages) {
        return undefined;
      }

      return loadedItems || 0;
    },
    staleTime: 1000 * 60 * 60,
    // 1 hour
    cacheTime: 1000 * 60 * 60 // 1 hour        

  });
  const items = data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.map(p => p === null || p === void 0 ? void 0 : p.items).flat();
  const totalItems = data === null || data === void 0 ? void 0 : (_data$pages$ = data.pages[0]) === null || _data$pages$ === void 0 ? void 0 : _data$pages$.totalItems;
  return {
    items,
    totalItems,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetching
  };
};
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/hooks/index.ts



;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/components/OrderHistory/OrderHistory.tsx


function OrderHistory_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OrderHistory_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OrderHistory_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OrderHistory_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const OrderHistory = () => {
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    isLoading: isUserInfoLoading
  } = useUserInformation();
  const {
    items: orderHistoryItems,
    totalItems,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isLoadingOrderHistory,
    isFetching
  } = useOrderHistory({
    skip: 0,
    take: 5
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleHeader */.RM, {
      headline: translate('profile.myOrders'),
      variant: "display3"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
      className: (OrderHistory_module_default()).headerText,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        className: (OrderHistory_module_default()).headerDate,
        variant: "display5",
        children: translate('profile.orderDate')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "display5",
        children: translate('profile.orderNumber')
      })]
    }), isUserInfoLoading || isLoadingOrderHistory ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (OrderHistory_module_default()).resWrapper,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Loader */.aN, {})
    }) : null, !isUserInfoLoading && !isLoadingOrderHistory ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Accordion */.UQ, {
      children: [orderHistoryItems === null || orderHistoryItems === void 0 ? void 0 : orderHistoryItems.map(order => {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* AccordionItem */.Qd, {
          header: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            className: (OrderHistory_module_default()).orderHeader,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "body",
              className: (OrderHistory_module_default()).headerDate,
              children: order.orderDate
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "body",
              children: order.orderNumber
            })]
          }),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderHistoryList, OrderHistory_objectSpread({}, order))
        }, order.orderNumber);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(features/* LoadMore */.fr, {
        total: totalItems,
        isFetching: isFetching && isFetchingNextPage,
        loaded: (orderHistoryItems === null || orderHistoryItems === void 0 ? void 0 : orderHistoryItems.length) || 0,
        hasNextPage: hasNextPage,
        onClick: fetchNextPage
      })]
    }) : null]
  });
};
// EXTERNAL MODULE: ./src/components/shared/PageHeaderContainer/PageHeaderContainer.tsx
var PageHeaderContainer = __webpack_require__(93724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-auth@4.22.0_sbludhwokvkmll3iw6eoi4ub3a/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(98);
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/components/OverviewPage/OverviewPage.module.css
var OverviewPage_module = __webpack_require__(20845);
var OverviewPage_module_default = /*#__PURE__*/__webpack_require__.n(OverviewPage_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/router.js
var router = __webpack_require__(38019);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-use@17.3.3_biqbaboplfbrettd7655fr4n2y/node_modules/react-use/esm/useSessionStorage.js
var useSessionStorage = __webpack_require__(71081);
// EXTERNAL MODULE: ./src/components/features/DownloadCustomerPrices/DownloadCustomerPrices.tsx
var DownloadCustomerPrices = __webpack_require__(9223);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/components/OverviewPage/OverviewPage.tsx














const OverviewPage = () => {
  var _userInformation$bill, _userInformation$bill2, _userInformation$bill3, _userInformation$bill4;

  const {
    locale,
    push
  } = (0,router.useRouter)();
  const translate = (0,cms/* useTranslations */.T_)();
  const {
    setPaymentOption
  } = (0,Basket/* useBasketState */.ZJ)();
  const {
    deleteBasket
  } = (0,Basket/* useBasket */.Kc)();
  const [, setShippingFormFields] = (0,useSessionStorage/* default */.Z)('shippingFormFields', {});
  const [, setFormFields] = (0,useSessionStorage/* default */.Z)('formFields', {});
  const [, setPaymentFormFields] = (0,useSessionStorage/* default */.Z)('paymentFormFields', {});
  const [, setBasketFields] = (0,useSessionStorage/* default */.Z)('basketFields', {});
  const [, setInvoiceFields] = (0,useSessionStorage/* default */.Z)('invoiceFields', {});
  const {
    data: userInformation,
    isLoading: isUserInfoLoading
  } = useUserInformation();

  const logOut = () => {
    setShippingFormFields({});
    setFormFields({});
    setPaymentFormFields({});
    setBasketFields({});
    setInvoiceFields({});
    setPaymentOption('payNow');
    deleteBasket();
    (0,next_auth_react.signOut)({
      redirect: false
    });
    push(`/${locale}`); //window.location.href = `/${locale}`
  };

  const downloadName = `${(userInformation === null || userInformation === void 0 ? void 0 : userInformation.accountNumber) || ''}-${(userInformation === null || userInformation === void 0 ? void 0 : userInformation.firstname) || ''}`;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: (OverviewPage_module_default()).overviewHeader,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleHeader */.RM, {
        headline: translate('profile.myOverview'),
        variant: "display3",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
          variant: "link",
          size: "large",
          className: (OverviewPage_module_default()).logoutButton,
          iconName: "login",
          onClick: logOut,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            className: (OverviewPage_module_default()).logoutText,
            variant: "bodySmall",
            children: translate('auth.logout')
          })
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: (OverviewPage_module_default()).flexWrapper,
      children: [isUserInfoLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (OverviewPage_module_default()).resWrapper,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Loader */.aN, {})
      }) : null, !isUserInfoLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (OverviewPage_module_default()).saldoWrapper,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "display3",
              className: (OverviewPage_module_default()).gridHeadline,
              children: translate('profile.balances')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
              variant: "bodySmall",
              children: [translate('profile.balance'), " "]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "bodySmall",
              children: userInformation === null || userInformation === void 0 ? void 0 : userInformation.balance
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadCustomerPrices/* default */.Z, {
            fileName: downloadName
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,clsx_m/* default */.Z)([(OverviewPage_module_default()).overviewWrapper]),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleHeader */.RM, {
            headline: translate('profile.myContacts'),
            variant: "display3"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: (OverviewPage_module_default()).contact,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                as: "h2",
                children: `${(userInformation === null || userInformation === void 0 ? void 0 : userInformation.firstname) || ''} ${(userInformation === null || userInformation === void 0 ? void 0 : userInformation.lastname) || ''}`
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                style: {
                  fontStyle: 'italic'
                },
                children: userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$bill = userInformation.billingAddress) === null || _userInformation$bill === void 0 ? void 0 : _userInformation$bill.street
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
                style: {
                  fontStyle: 'italic'
                },
                children: [userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$bill2 = userInformation.billingAddress) === null || _userInformation$bill2 === void 0 ? void 0 : _userInformation$bill2.zipCode, " ", userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$bill3 = userInformation.billingAddress) === null || _userInformation$bill3 === void 0 ? void 0 : _userInformation$bill3.city]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                style: {
                  fontStyle: 'italic'
                },
                children: userInformation === null || userInformation === void 0 ? void 0 : (_userInformation$bill4 = userInformation.billingAddress) === null || _userInformation$bill4 === void 0 ? void 0 : _userInformation$bill4.country
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                children: userInformation === null || userInformation === void 0 ? void 0 : userInformation.email
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                children: userInformation === null || userInformation === void 0 ? void 0 : userInformation.phone
              })]
            })
          })]
        })]
      }) : null]
    })]
  });
};
// EXTERNAL MODULE: ./src/page-type/page-types/P181Profile/components/WatchList/WatchList.module.css
var WatchList_module = __webpack_require__(27756);
var WatchList_module_default = /*#__PURE__*/__webpack_require__.n(WatchList_module);
// EXTERNAL MODULE: ./src/components/shared/ErrorBox/ErrorBox.tsx
var ErrorBox = __webpack_require__(50764);
// EXTERNAL MODULE: ./src/components/features/Favorites/FavoriteCard/FavoriteCard.tsx
var FavoriteCard = __webpack_require__(84580);
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/components/WatchList/WatchList.tsx










const WatchList = () => {
  var _watchList$items, _watchList$items2;

  const translate = (0,cms/* useTranslations */.T_)();
  const {
    data: watchList,
    isLoading,
    isError
  } = useWatchlist();

  const header = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleHeader */.RM, {
    headline: translate('profile.stockWatchlist'),
    variant: "display3"
  });

  if (isLoading) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [header, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Loader */.aN, {})]
    });
  }

  if (isError) return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [header, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBox/* default */.Z, {})]
  });
  if (watchList && !((_watchList$items = watchList.items) !== null && _watchList$items !== void 0 && _watchList$items.length)) return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [header, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      children: translate('profile.emptyWatchlist')
    })]
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: (WatchList_module_default()).list,
    children: [header, watchList === null || watchList === void 0 ? void 0 : (_watchList$items2 = watchList.items) === null || _watchList$items2 === void 0 ? void 0 : _watchList$items2.map((item, i) => (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FavoriteCard/* default */.Z, {
      item: item
    }, `${item === null || item === void 0 ? void 0 : item.productId}-${i}`))]
  });
};
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/components/index.ts



;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/P181ProfilePage.tsx










var ProfileTabsContent;

(function (ProfileTabsContent) {
  ProfileTabsContent[ProfileTabsContent["Overview"] = 0] = "Overview";
  ProfileTabsContent[ProfileTabsContent["OrderHistory"] = 1] = "OrderHistory";
  ProfileTabsContent[ProfileTabsContent["StockStatus"] = 2] = "StockStatus";
})(ProfileTabsContent || (ProfileTabsContent = {}));

const P181ProfilePage = () => {
  const {
    0: activeTab,
    1: setActiveTab
  } = (0,react.useState)(ProfileTabsContent.Overview);
  const {
    isAuthenticating,
    isAuthenticated,
    session
  } = (0,hooks/* useAuthentication */.JL)();
  const translate = (0,cms/* useTranslations */.T_)();

  if (isAuthenticating) {
    return null;
  }

  if (!session || !isAuthenticated) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* ModuleContainer */.EM, {
      hasGutter: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "display2",
        children: translate('auth.unauthenticated.title')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "body",
        children: translate('auth.unauthenticated.title')
      })]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* ModuleContainer */.EM, {
      hasGutter: true,
      hasPadding: false,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Tabs */.mQ, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TabButton */.Y6, {
            isActive: activeTab === ProfileTabsContent.Overview,
            onClick: () => setActiveTab(ProfileTabsContent.Overview),
            children: translate('profile.overview')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TabButton */.Y6, {
            isActive: activeTab === ProfileTabsContent.OrderHistory,
            onClick: () => setActiveTab(ProfileTabsContent.OrderHistory),
            children: translate('profile.myOrders')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* TabButton */.Y6, {
            isActive: activeTab === ProfileTabsContent.StockStatus,
            onClick: () => setActiveTab(ProfileTabsContent.StockStatus),
            children: translate('profile.stockWatchlist')
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageHeaderContainer/* default */.Z, {
      children: activeTab === ProfileTabsContent.OrderHistory ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderHistory, {}) : activeTab === ProfileTabsContent.StockStatus ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WatchList, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewPage, {})
    })]
  });
};
;// CONCATENATED MODULE: ./src/page-type/page-types/P181Profile/index.ts



/***/ }),

/***/ 71945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s2": function() { return /* reexport */ useCountryOptions; },
  "cI": function() { return /* reexport */ useForm; },
  "Zh": function() { return /* reexport */ useValidationRules; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hook-form@7.39.7_react@18.2.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(40505);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.39.7/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(2924);
// EXTERNAL MODULE: ../../node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(99068);
;// CONCATENATED MODULE: ./src/shared/utils/form/config/setValidationLocale.ts

let localeConfig = null;
const setValidationLocale = translator => {
  if (!localeConfig) {
    localeConfig = getLocaleConfig(translator);
    (0,es/* setLocale */.i_)(localeConfig);
  }
};
/**
 * Returns the locale config for the current locale.
 * Add all localized validation messages here.
 * Fallback to english if no translation is available.
 *
 * Supply translation key from validation error messages.
 */

const getLocaleConfig = translator => {
  return {
    mixed: {
      default: () => translator('form.validation.default'),
      required: () => translator('form.validation.required')
    },
    string: {
      email: () => translator('form.validation.email'),
      min: _ref => {
        let {
          min
        } = _ref;
        return translator('form.validation.min', [{
          key: 'min',
          value: min
        }]);
      },
      max: _ref2 => {
        let {
          max
        } = _ref2;
        return translator('form.validation.max', [{
          key: 'max',
          value: max
        }]);
      },
      matches: _ref3 => {
        let {
          originalValue
        } = _ref3;
        return translator('form.validation.matches', [{
          key: 'originalValue',
          value: originalValue
        }]);
      }
    },
    number: {
      min: _ref4 => {
        let {
          min
        } = _ref4;
        return translator('form.validation.min', [{
          key: 'min',
          value: min
        }]);
      },
      max: _ref5 => {
        let {
          max
        } = _ref5;
        return translator('form.validation.max', [{
          key: 'max',
          value: max
        }]);
      },
      integer: () => translator('form.validation.integer')
    }
  };
};
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94965);
;// CONCATENATED MODULE: ./src/shared/utils/form/hooks/useForm/useForm.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * Use this hook to create a form with validation.
 * Use in coherence with Yup validation schema.
 * and Yup resolver.´
 *
 * Pass Yup validation schema as props.validationSchema
 */
const useForm = props => {
  const translate = (0,cms/* useTranslations */.T_)();
  setValidationLocale(translate);
  const resolver = props !== null && props !== void 0 && props.validationSchema ? {
    resolver: (0,yup/* yupResolver */.X)(props.validationSchema)
  } : {};
  return (0,index_esm/* useForm */.cI)(_objectSpread(_objectSpread({}, resolver), props));
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/components/features/Basket/index.ts + 9 modules
var Basket = __webpack_require__(55057);
;// CONCATENATED MODULE: ./src/shared/utils/form/hooks/useValidationRules/useValidationRules.tsx



/**
 * Use this hook to get the validation rules for a country.
 * @param props
 * @returns {CountryRules}
 * @example
 * const { rules } = useValidationRules({ countryCode: 'US' });
 * const { rules: rules2 } = useValidationRules({ countryCode: 'CA' });
 * console.log(rules.zipCode.maxLength); // 5
 * console.log(rules2.zipCode.maxLength); // 7
 */
const useValidationRules = countryCodeProp => {
  var _basket$deliveryInfor, _basket$deliveryInfor2;

  const {
    data: basket
  } = (0,Basket/* useBasket */.Kc)();
  const countryCodeToHit = countryCodeProp || (basket === null || basket === void 0 ? void 0 : (_basket$deliveryInfor = basket.deliveryInformationViewModel) === null || _basket$deliveryInfor === void 0 ? void 0 : (_basket$deliveryInfor2 = _basket$deliveryInfor.invoiceAddress) === null || _basket$deliveryInfor2 === void 0 ? void 0 : _basket$deliveryInfor2.countryCode);
  const harcodedValidationRules = [{
    countryCode: 'DK',
    zipcodeFallback: '9200',
    phonePrefix: '45',
    zipcodeRegex: '\\w',
    phoneRegex: null,
    minimumPhoneLength: 8,
    maximumPhoneLength: 20,
    debitorCode: '008',
    tailorCountryCode: 'WEB',
    alias: 'countryRules'
  }, {
    countryCode: 'DE',
    zipcodeRegex: '\\w',
    phoneRegex: null,
    minimumPhoneLength: 8,
    maximumPhoneLength: 20,
    debitorCode: '008',
    tailorCountryCode: 'WEB',
    alias: 'countryRules'
  }, {
    countryCode: 'FR',
    zipcodeRegex: '\\w',
    phoneRegex: null,
    minimumPhoneLength: 8,
    maximumPhoneLength: 20,
    debitorCode: '008',
    tailorCountryCode: 'WEB',
    alias: 'countryRules'
  }, {
    countryCode: 'EN',
    zipcodeRegex: '\\w',
    phoneRegex: null,
    minimumPhoneLength: 8,
    maximumPhoneLength: 20,
    debitorCode: '008',
    tailorCountryCode: 'WEB',
    alias: 'countryRules'
  }];
  const validationRules = (0,react.useMemo)(() => (harcodedValidationRules === null || harcodedValidationRules === void 0 ? void 0 : harcodedValidationRules.find(_ref => {
    let {
      countryCode
    } = _ref;
    return countryCode.toLocaleLowerCase() === (countryCodeToHit === null || countryCodeToHit === void 0 ? void 0 : countryCodeToHit.toLocaleLowerCase());
  })) || {}, [countryCodeToHit]);
  return validationRules;
};
;// CONCATENATED MODULE: ./src/shared/utils/form/hooks/useCountryOptions/useCountryOptions.tsx
const INTERNATIONAL_KEY = 'DK';
/**
 * Use this hook to get the delivery options for a country.
 * @param props
 * @example
 * const { options } = useDeliveryOptions({ countryCode: 'US' });
 * console.log(options);
 */

const useCountryOptions = countryKey => {
  const deliveryOptions = [{
    title: 'Denmark',
    value: 'DK'
  }]; // Don't ever use INT as a country key.

  const currentDeliveryKey = countryKey === INTERNATIONAL_KEY ? INTERNATIONAL_KEY : countryKey;
  const currentCountryName = countryKey === INTERNATIONAL_KEY ? INTERNATIONAL_KEY.toLocaleUpperCase() : countryKey;
  return {
    deliveryOptions: deliveryOptions || [],
    currentDeliveryKey,
    currentCountryName
  };
};
;// CONCATENATED MODULE: ./src/shared/utils/form/index.ts




/***/ }),

/***/ 64160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jl": function() { return /* reexport */ deleteRequest; },
  "LJ": function() { return /* reexport */ generateImageUrl; },
  "wP": function() { return /* reexport */ generatePDPLink; },
  "Al": function() { return /* reexport */ generateRelatedUrl; },
  "A_": function() { return /* reexport */ getRequest; },
  "yF": function() { return /* reexport */ isSSR; },
  "j0": function() { return /* reexport */ postRequest; },
  "GH": function() { return /* reexport */ putRequest; },
  "cI": function() { return /* reexport */ utils_form/* useForm */.cI; },
  "aN": function() { return /* reexport */ useGetRequest; },
  "Zh": function() { return /* reexport */ utils_form/* useValidationRules */.Zh; }
});

// UNUSED EXPORTS: RequestProvider, buildURL, hasEmptyProperties, isBrowser, isObject, omit, useCountryOptions

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(12445);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(21175);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var lib_QueryClientProvider = __webpack_require__(31781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.10.3_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(72603);
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/buildURL.ts
/**
 * Allows pasing number and boolean as values.
 * Follows the `a=1&a=2` standard and not the default
 * `a=1,2` standard
 */
const buildSearchParams = params => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(_ref => {
    let [key, value] = _ref;

    if (value === null || typeof value === 'undefined') {
      return;
    }

    const valueArray = Array.isArray(value) ? value.sort() : [value];
    valueArray.forEach(v => {
      searchParams.append(key, v.toString());
    });
  });
  searchParams.sort();
  return searchParams;
};
/**
 * Get base, hash and search part of url
 
 * `baseUrl` the origin with pathname.
 * `search` search queries without `?`.
 * `hash` hashtag value without `#`.
 */


const parseUrl = url => {
  // Remove everything after the first instance of ? or #
  const baseUrl = url.replace(/(\?|#).*/, '');
  const queryString = url.replace(baseUrl, ''); // Assume hashtag comes first
  // eg. #hash-id?color=red

  const [hashValue = '', searchValue = ''] = queryString.split('?');
  let hash = hashValue.replace('#', '');
  let search = searchValue; // Reverse if hashtag in search

  if (searchValue.includes('#')) {
    const [searchValue, hashValue] = search.split('#');
    search = searchValue.replace('?', '');
    hash = hashValue;
  }

  return {
    baseUrl,
    search,
    hash
  };
};
/**
 * Adds query params to an url. Ensuring a deterministic url.
 * Useful when using the url as a unique identifier and need to compare
 *
 * NOTE: hashtag values are deliberately excluded eg. https://example.com/#hashtag-id
 */


const buildURL = (url, params) => {
  const {
    baseUrl,
    search
  } = parseUrl(url);
  const searchParams = new URLSearchParams(search);

  if (params) {
    const serializedParams = buildSearchParams(params);
    serializedParams.forEach((value, key) => searchParams.append(key, value));
  } // Ensures deterministic params


  searchParams.sort();
  const newSearch = searchParams.toString();
  return newSearch ? `${baseUrl}?${newSearch}` : baseUrl;
};
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/fetcher.ts
const fetcher = (url, options) => async () => {
  const response = await fetch(url, options); //const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    console.error(`${response.status} ${response.statusText} at ${url}`);
    return Promise.reject(response);
  }

  const data = await response.json();
  return data;
};
;// CONCATENATED MODULE: ./src/shared/utils/request/hooks/useGetRequest.ts


const _excluded = ["params", "headers"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/**
 * Helper method for useQuery (https://react-query.tanstack.com/reference/useQuery)
 *
 * Added:
 * - url + params are used as the key
 * - `mutation` helper method inspired by useSWR.
 * - `isValidating` helper value inspired by useSWR
 * - `invalidate` helper method to invalidate and refetch data
 *
 * Using React Query over useSWR to future proof the codebase.
 * Read all available benefits here:
 * NOTE: not all features are implemented yet.
 * @see https://react-query.tanstack.com/comparison
 */
const useGetRequest = (url, options) => {
  const _ref = options || {},
        {
    params,
    headers
  } = _ref,
        otherOptions = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded); // Generate a determanistic URL based on url + params


  const serializedUrl = buildURL(url, params);
  const queryClient = (0,lib_QueryClientProvider/* useQueryClient */.NL)(); // Use determanistic generated URL as key

  const query = (0,useQuery/* useQuery */.a)([serializedUrl], fetcher(serializedUrl, {
    headers
  }), _objectSpread({}, otherOptions));
  const isValidating = query.isFetching; // Helper method for invalidating

  const invalidate = () => queryClient.invalidateQueries([serializedUrl]); // Helper method for mutating the stored state


  const mutate = function (newValue) {
    let invalidateQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    queryClient.setQueryData([serializedUrl], () => newValue);

    if (invalidateQuery) {
      invalidate();
    }
  };

  return _objectSpread(_objectSpread({}, query), {}, {
    isValidating,
    mutate,
    invalidate
  });
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+query-core@4.10.3/node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 1 modules
var queryClient = __webpack_require__(708);
;// CONCATENATED MODULE: ./src/shared/utils/request/context/RequestProvider.tsx


/**
 * Find default query options as
 * `QueryObserverOptions` at https://github.com/tannerlinsley/react-query/blob/master/src/core/types.ts
 */


const RequestProvider_queryClient = new queryClient/* QueryClient */.S({
  defaultOptions: {
    queries: {
      // Disabled since we don't rely on realtime data
      refetchOnWindowFocus: false,
      // Time before revalidating data. Set to 5min to
      // match reactQuery's default cache time
      staleTime: 30000
    }
  }
});
const RequestProvider = _ref => {
  let {
    children,
    state
  } = _ref;
  return _jsx(QueryClientProvider, {
    client: RequestProvider_queryClient,
    children: _jsx(Hydrate, {
      state: state,
      children: children
    })
  });
};
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/getRequest.ts


function getRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Simpler version of a GET request, supplies content type
 */

const getRequest = function (url) {
  let headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const opts = {
    method: 'GET',
    headers: getRequest_objectSpread({
      'Content-Type': 'application/json; charset=utf-8'
    }, headers)
  };
  return fetcher(url, opts);
};
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/postRequest.ts


function postRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function postRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? postRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : postRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Simpler version of a POST request, supplies content type and serializes body to json
 */

const postRequest = function (url, body) {
  let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let isForm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const opts = {
    method: 'POST'
  };

  if (body && !isForm) {
    opts['body'] = JSON.stringify(body);
  }

  if (body && isForm) {
    //@ts-ignore
    opts['body'] = body;
  }

  if (!isForm) {
    opts.headers = postRequest_objectSpread({
      'Content-Type': 'application/json; charset=utf-8'
    }, headers);
  } else {
    opts.headers = postRequest_objectSpread(postRequest_objectSpread({}, opts.headers), headers);
  }

  return fetcher(url, opts);
};
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/deleteRequest.ts


function deleteRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function deleteRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? deleteRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : deleteRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Simpler version of a DELETE request, supplies content type and serializes body to json
 */

const deleteRequest = function (url, body) {
  let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const opts = {
    method: 'DELETE',
    headers: deleteRequest_objectSpread({
      'Content-Type': 'application/json; charset=utf-8'
    }, headers)
  };

  if (body) {
    opts['body'] = JSON.stringify(body);
  }

  return fetcher(url, opts);
};
;// CONCATENATED MODULE: ./src/shared/utils/request/utils/putRequest.ts


function putRequest_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function putRequest_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? putRequest_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : putRequest_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Simpler version of a PUT request, supplies content type and serializes body to json
 */

const putRequest = function (url, body) {
  let headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let abortSignal = arguments.length > 3 ? arguments[3] : undefined;
  return fetcher(url, {
    method: 'PUT',
    headers: putRequest_objectSpread({
      'Content-Type': 'application/json; charset=utf-8'
    }, headers),
    body: JSON.stringify(body),
    signal: abortSignal
  });
};
;// CONCATENATED MODULE: ./src/shared/utils/request/index.ts








;// CONCATENATED MODULE: ./src/shared/utils/platform/utils/platform.ts
const isSSR = false;
const isBrowser = !isSSR;
;// CONCATENATED MODULE: ./src/shared/utils/platform/index.ts

// EXTERNAL MODULE: ./src/shared/utils/form/index.ts + 4 modules
var utils_form = __webpack_require__(71945);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.2_oszf7dt2qvdtfacaaz5ryqyqi4/node_modules/next/config.js
var config = __webpack_require__(51347);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/shared/utils/public-variables/runtime-config.ts
var _getConfig;


const publicRuntimeConfig = (_getConfig = config_default()()) === null || _getConfig === void 0 ? void 0 : _getConfig.publicRuntimeConfig;
const API_URL = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.API_URL;
const COMMERCE_API_URL = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.COMMERCE_API_URL;
const LICENSE_PLATE_API_URL = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.LICENSE_PLATE_API_URL;
const APPINSIGHTS_INSTRUMENTATIONKEY = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.APPINSIGHTS_INSTRUMENTATIONKEY;
const APPINSIGHTS_CONNECTION_STRING = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.APPINSIGHTS_CONNECTION_STRING;
const IMAGE_CDN_URL = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.IMAGE_CDN_URL;
const HOSTNAME_URL = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.HOSTNAME_URL;
const HOSTNAME_KEY = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.HOSTNAME_KEY;
const RELEWISE_KEY = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.RELEWISE_KEY;
const RELEWISE_DATASET = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.RELEWISE_DATASET;
;// CONCATENATED MODULE: ./src/shared/utils/public-variables/index.ts

;// CONCATENATED MODULE: ./src/shared/utils/media/generate-media-url.ts

function generateImageUrl(_ref) {
  let {
    size,
    fileName,
    modifiedDateTime
  } = _ref;
  const baseUrl = `${IMAGE_CDN_URL}/pictures`;
  return `${baseUrl}/${size}/${fileName}?cachebuster=${modifiedDateTime}`;
}
function generateRelatedUrl(_ref2) {
  let {
    fileName,
    modifiedDateTime,
    inspectedFileType
  } = _ref2;
  const baseUrl = `${IMAGE_CDN_URL}/pictures/${inspectedFileType === 'MP3' ? 'sound' : 'pdf'}`;
  return `${baseUrl}/${fileName}?cachebuster=${modifiedDateTime}`;
}
;// CONCATENATED MODULE: ./src/shared/utils/media/index.ts

;// CONCATENATED MODULE: ./src/shared/utils/product/generate-pdp-link.ts
const generatePDPLink = props => {
  const {
    displayName = 'product',
    productId,
    variantId
  } = props;
  const name = displayName.replace(/[./, ]/g, "-");
  return `/p/${encodeURIComponent(name)}/${productId}/${variantId}`;
};
;// CONCATENATED MODULE: ./src/shared/utils/product/index.ts

;// CONCATENATED MODULE: ./src/shared/utils/index.ts








/***/ }),

/***/ 3905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"BackArrow_arrowButton__PhFpA"};

/***/ }),

/***/ 31787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"FilterList_filterContainer__ZVPSX"};

/***/ }),

/***/ 70405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineItem":"LineItem_lineItem__V6cPD","lineFavorites":"LineItem_lineFavorites__FpbQT","lineStepper":"LineItem_lineStepper__sgvYY","dispensableText":"LineItem_dispensableText__GnjG3","productLink":"LineItem_productLink__53jZh","linePrice":"LineItem_linePrice__EspB7"};

/***/ }),

/***/ 75473:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__QvXDY","summaryText":"Summary_summaryText___lzO4","summaryDivider":"Summary_summaryDivider__vRFjp","descriptionTableData":"Summary_descriptionTableData__TPFnd","summaryTableData":"Summary_summaryTableData__SPATk","discount":"Summary_discount__KhJPx"};

/***/ }),

/***/ 58428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomerPrice_root___7uar","leftAlign":"CustomerPrice_leftAlign__ZUnuS","rightAlign":"CustomerPrice_rightAlign__aeYFa","skeletonPrice":"CustomerPrice_skeletonPrice__uFDGl","skeletonPriceLarge":"CustomerPrice_skeletonPriceLarge__DP172"};

/***/ }),

/***/ 55601:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"AddFavoriteButton_button__xSFEw cleanButton","icon":"AddFavoriteButton_icon__RD3kO","iconWrapper":"AddFavoriteButton_iconWrapper__2ieOK","loader":"AddFavoriteButton_loader__8uuo0","iconSelected":"AddFavoriteButton_iconSelected__G1RT8 AddFavoriteButton_icon__RD3kO"};

/***/ }),

/***/ 67116:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FavoriteCard_root__mSXmB","productLink":"FavoriteCard_productLink__tdHO7","baseProductInfo":"FavoriteCard_baseProductInfo__dNcsE","price":"FavoriteCard_price__bHI5G","stockStatus":"FavoriteCard_stockStatus__6ksNT","addToBasket":"FavoriteCard_addToBasket__2ycPq","addFavorite":"FavoriteCard_addFavorite__N_mrV"};

/***/ }),

/***/ 10799:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__MrQdP"};

/***/ }),

/***/ 24803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceGroup_price__MV2Us","modifierOriginal":"PriceGroup_modifierOriginal__HDiEf","modifierDiscounted":"PriceGroup_modifierDiscounted__qb0q9","priceGroup":"PriceGroup_priceGroup__cEglR","priceGroupHorizontal":"PriceGroup_priceGroupHorizontal__501G5","priceGroupVertical":"PriceGroup_priceGroupVertical__SLmje","priceUnit":"PriceGroup_priceUnit__20DcY"};

/***/ }),

/***/ 45122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveFacets_root__0TKpb","buttonWrapper":"ActiveFacets_buttonWrapper__rLEGd","skeleton":"ActiveFacets_skeleton__ps9VN","facetsWrapper":"ActiveFacets_facetsWrapper__H2hEX"};

/***/ }),

/***/ 36308:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Facets_root__258ji"};

/***/ }),

/***/ 91129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"FacetsFilter_root__hB2ct"};

/***/ }),

/***/ 44796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMore_root__NQMFB","progress":"LoadMore_progress___eLP1"};

/***/ }),

/***/ 74342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productList":"ProductList_productList__ckXm1","header":"ProductList_header__evtZx","headerLeft":"ProductList_headerLeft__z_WOh","headerRight":"ProductList_headerRight__u56df","skeletonItem":"ProductList_skeletonItem__Gd10Z","plpTitle":"ProductList_plpTitle__cIxLd"};

/***/ }),

/***/ 16408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Sorting_root__juPMO","controls":"Sorting_controls__Ghsau","select":"Sorting_select__7jqKd"};

/***/ }),

/***/ 67198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__KcTn0","partCriteriasContainer":"Card_partCriteriasContainer__QXh4M","partCriterias":"Card_partCriterias___1ajo cleanList","linkageItem":"Card_linkageItem__Aws5z","addToBasketSection":"Card_addToBasketSection__TZFF5","productLink":"Card_productLink___j9Gm","splashesContainer":"Card_splashesContainer__zKpM9","priceArea":"Card_priceArea__wyZgx","sotckStatus":"Card_sotckStatus__kHyJn","addToBasket":"Card_addToBasket__a0uP8","skeletonImageContainer":"Card_skeletonImageContainer__eBN_a","addFavoriteBtn":"Card_addFavoriteBtn___3e4A","price":"Card_price__GohJA","linkagesContainer":"Card_linkagesContainer__KzSNL","stockStatus":"Card_stockStatus__Idke5"};

/***/ }),

/***/ 60090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"StockStatus_root__Vzojy","status":"StockStatus_status__bq_5L","watchStock":"StockStatus_watchStock__Z27qq cleanButton","icon":"StockStatus_icon__nS__Z","status0":"StockStatus_status0__qQxzj StockStatus_status__bq_5L","status1":"StockStatus_status1__kVtN5 StockStatus_status__bq_5L","status2":"StockStatus_status2__9lCG4 StockStatus_status__bq_5L","status3":"StockStatus_status3__ZLFQp StockStatus_status__bq_5L"};

/***/ }),

/***/ 95243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"SidebarFilter_header__phqZV","listItem":"SidebarFilter_listItem__J9wE_","subList":"SidebarFilter_subList__wkyS1","skeletonListItem":"SidebarFilter_skeletonListItem__JZFfk SidebarFilter_listItem__J9wE_","skeletonButtonItem":"SidebarFilter_skeletonButtonItem__YXd5d","subListItem":"SidebarFilter_subListItem__qnujM","button":"SidebarFilter_button__kXOGi cleanButton","subCategoryText":"SidebarFilter_subCategoryText__938pq","sidebarCategoryHeader":"SidebarFilter_sidebarCategoryHeader__TCfuX"};

/***/ }),

/***/ 1496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseProductInfo_root__MZSav","productName":"BaseProductInfo_productName__4mdty","description":"BaseProductInfo_description___Avgp","flexInfo":"BaseProductInfo_flexInfo__QatIs","expressInfo":"BaseProductInfo_expressInfo__SCdyI"};

/***/ }),

/***/ 42014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorBox_root__w8x_3","errorBox":"ErrorBox_errorBox__v4Z6q"};

/***/ }),

/***/ 12389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeaderContainer_root__O4Hzr","rootWithPadding":"PageHeaderContainer_rootWithPadding__nVIPD PageHeaderContainer_root__O4Hzr"};

/***/ }),

/***/ 69050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerText":"OrderHistory_headerText__PL22i","accordionText":"OrderHistory_accordionText___sLay","resWrapper":"OrderHistory_resWrapper__CyX95","orderHeader":"OrderHistory_orderHeader__IOLxH"};

/***/ }),

/***/ 44334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gridRoot":"OrderHistoryList_gridRoot__fJ_rj","divItem":"OrderHistoryList_divItem__DxQDZ","partNo":"OrderHistoryList_partNo__X2Irx","description":"OrderHistoryList_description__jqSdd","quantity":"OrderHistoryList_quantity__higYX","customer":"OrderHistoryList_customer__eLKmK","item":"OrderHistoryList_item___vU14","partData":"OrderHistoryList_partData__0CyiD","partDesc":"OrderHistoryList_partDesc__HhE5A","partQty":"OrderHistoryList_partQty__1_q_P","partCustom":"OrderHistoryList_partCustom__tWDgT"};

/***/ }),

/***/ 20845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"OverviewPage_flexWrapper__Qc_aC","overviewWrapper":"OverviewPage_overviewWrapper__ZrrW2","saldoWrapper":"OverviewPage_saldoWrapper__RlVLO OverviewPage_overviewWrapper__ZrrW2","listItem":"OverviewPage_listItem__Khzcz","gridItem":"OverviewPage_gridItem__495HA","contact":"OverviewPage_contact__90xvL","overviewHeader":"OverviewPage_overviewHeader__Csq86","logoutButton":"OverviewPage_logoutButton__SwcEQ","logoutText":"OverviewPage_logoutText__8Ijw3","resWrapper":"OverviewPage_resWrapper__7PsSG","price":"OverviewPage_price__h4cmH"};

/***/ }),

/***/ 27756:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resWrapper":"WatchList_resWrapper__qZRaO","list":"WatchList_list__3xkDq"};

/***/ }),

/***/ 71437:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"AddToBasket_root__ZO12g"};

/***/ }),

/***/ 15850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stickySection":"MobileFilters_stickySection__Xl1_C","filterRoot":"MobileFilters_filterRoot___y6_Q"};

/***/ }),

/***/ 23230:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk2cHgiIGhlaWdodD0iMzY5cHgiIHZpZXdCb3g9IjAgMCAyOTYgMzY5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPmltYWdlcy8gcG9ydHJhaXQvcHJvZHVjdDwvdGl0bGU+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImltYWdlcy8tcG9ydHJhaXQiPgogICAgICAgICAgICA8cmVjdCBpZD0iUG9ydHJhaXQtaW1hZ2UiIGZpbGw9IiNGOEY3RjciIHg9IjAiIHk9IjAiIHdpZHRoPSIyOTYiIGhlaWdodD0iMzY5Ij48L3JlY3Q+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTMuMTAxNTQ5LCAxNjEuNjI4MDk5KSIgb3BhY2l0eT0iMC4zIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNBRUFFQUYiIHBvaW50cz0iMTUuNTM3OTIyOCAyOS44ODU5NTA0IDMxLjIzMTE1NjEgNDUuNTQwNDk1OSAwIDQ1LjU0MDQ5NTkiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsIiBmaWxsPSIjQUVBRUFGIiBjeD0iMTYuMzI1Mzc3MSIgY3k9IjcuODI3MjcyNzMiIHJ4PSI3LjgwNzc4OTAzIiByeT0iNy44MjcyNzI3MyI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzFFMUQxRCIgcG9pbnRzPSI0NS41NDQ4OTk4IDIxLjgyMTQ4NzYgNjkuNTYwMzAyMiA0NS41NDA0OTU5IDIxLjc2NzE2OTQgNDUuNTQwNDk1OSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 2684:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 21916:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 36460:
/***/ (function() {

/* (ignored) */

/***/ })

}]);